import { jsx as d, jsxs as M, Fragment as mt } from "react/jsx-runtime";
import * as Br from "react";
import J, { forwardRef as de, useRef as _e, useMemo as xe, useImperativeHandle as at, useId as Mr, useCallback as Ye, createElement as Ds, useState as pe, isValidElement as Rs, cloneElement as ot, useEffect as Be, Children as Ls, useContext as Or, createContext as Pr } from "react";
import { TOAST_POSITION_ANIMATION_MATRIX as Tr } from "./components/Toaster/Toaster.types.js";
import { c as R } from "./index-Cu0xwYjD.js";
import { TextMode as Hr, HeadingLevel as Cs, SystemValidationStatus as Ur, GlobalCSSClass as ae, TextFieldType as zs, FormElementWidth as Wt, Breakpoint as Es, DisplayMode as qr, BREAKPOINTS as ms, GutterSize as jt, HorizontalAlign as Bs, VerticalAlign as Ms, ModalSize as Wr, PaddingSize as Os } from "./utils/enums.js";
import { IressStack as ps } from "./components/Stack/Stack.js";
import { u as Qt, c as Ps, d as Ts, e as Hs, q as Gt, F as Nt, r as Us, k as qs } from "./floating-ui.react-DxYXKqW-.js";
import { timeStringToNumber as Ws, getTransitionDuration as jr } from "./utils/helpers.transitions.js";
import { IconSpin as Qr, IconSize as js, IconFlip as Gr, IconRotate as Kr, IconSet as Xr } from "./components/Icon/Icon.types.js";
import { ALERT_ICONS as Yr } from "./components/Alert/Alert.types.js";
import { IressText as pt } from "./components/Text/Text.js";
import { propagateTestid as k, toArray as Fe, idsLogger as Kt } from "./utils/helpers.js";
import { HeadingWithDeprecatedFallback as Qs } from "./utils/components/HeadingWithDeprecatedFallback.js";
import { s as bt, A as Xt } from "./AutocompleteNoResults-CUHAHNCv.js";
import { IressPopover as Jr } from "./components/Popover/Popover.js";
import { IressInputPopover as Yt } from "./components/Popover/InputPopover/InputPopover.js";
import { getFormControlValueAsString as Gs, getFormControlValueAsStringIfDefined as Ft, getValueAsEvent as qe } from "./utils/helpers.form.js";
import { ClearButton as Zr } from "./components/Input/ClearButton/ClearButton.js";
import { I as ei, b as ti } from "./InputBase-b3u80VBV.js";
import { InputMode as si } from "./components/Input/Input.types.js";
import { useControlledState as Dt } from "./utils/hooks/useControlledState.js";
import { useIdIfNeeded as Le } from "./utils/hooks/useIdIfNeeded.js";
import { s as ri, S as ii } from "./SelectControl-uz0q4u9R.js";
import { mapNodesToSelectOptions as Ks, findValueFromStringInSelectOptions as ni } from "./components/Select/helpers/nodesToSelectOptions.js";
import { getValueFromLabelValues as oi } from "./utils/helpers.label-value.js";
import "./components/Badge/Badge.js";
import { ButtonMode as ai, ButtonType as li, ButtonCssClass as Qe } from "./components/Button/Button.types.js";
import { u as di } from "./useIDSButtonGroupItem-B6pjgOX2.js";
import "./components/ButtonGroup/ButtonGroupProvider.js";
import "./components/Card/Card.js";
import { IressCheckbox as ci } from "./components/Checkbox/Checkbox.js";
import { IressCheckboxGroup as ui } from "./components/CheckboxGroup/CheckboxGroup.js";
import "./components/Col/Col.js";
import { s as je, C as Xs } from "./ComboboxHiddenInput-BeCR83Ln.js";
import { IressMenu as fi } from "./components/Menu/Menu.js";
import { useAutocompleteSearch as Rt } from "./components/Autocomplete/hooks/useAutocompleteSearch.js";
import "./components/Expander/Expander.js";
import { FormDefaultText as mi } from "./components/Form/Form.types.js";
import { getErrorTypeMessage as Jt } from "./components/Form/Controller/helpers/getErrorTypeMessage.js";
import { IressLabel as pi } from "./components/Label/Label.js";
import { IressRadioGroup as vi } from "./components/RadioGroup/RadioGroup.js";
import "./components/Menu/MenuProvider.js";
import "./components/Menu/MenuHeading/MenuHeading.js";
import { useMenuItemRole as hi } from "./components/Menu/MenuItem/hooks/useMenuItemRole.js";
import { useMenuItemAria as gi } from "./components/Menu/MenuItem/hooks/useMenuItemAria.js";
import { useMenuItemButtonProps as yi } from "./components/Menu/MenuItem/hooks/useMenuItemButtonProps.js";
import { useMenuItemInteractions as bi } from "./components/Menu/MenuItem/hooks/useMenuItemInteractions.js";
import { useMenuItemComposite as _i } from "./components/Menu/MenuItem/hooks/useMenuItemComposite.js";
import "./components/CheckboxMark/CheckboxMark.types.js";
import "./components/CheckboxMark/CheckboxMark.js";
import "./components/Popover/PopoverProvider.js";
import { s as Ot, S as xi } from "./SliderTicks-C-1IXfwI.js";
import { InlineCssClass as rt } from "./components/Inline/Inline.types.js";
import { getResponsiveLayoutModifiers as Zt } from "./utils/helpers.responsive.js";
import { useIDSProvidedModal as Si } from "./components/Modal/hooks/useIDSProvidedModal.js";
import "./components/Modal/ModalProvider.js";
import { NavbarHorizontalAlign as Ni } from "./components/Navbar/Navbar.types.js";
import { IressPanel as It } from "./components/Panel/Panel.js";
import { HideCssClass as vs } from "./components/Hide/Hide.types.js";
import "./components/Radio/Radio.js";
import { RowCssClass as dt } from "./components/Row/Row.types.js";
import "./components/Skeleton/Skeleton.js";
import "./components/SkipLink/SkipLink.js";
import { SlideoutMode as Fi, SlideoutPosition as Ii, SlideoutSize as wi } from "./components/Slideout/Slideout.types.js";
import { useIDSProvidedSlideout as Vi } from "./components/Slideout/hooks/useIDSProvidedSlideout.js";
import "./components/Slideout/SlideoutProvider.js";
import { TableScope as Ai } from "./components/Table/Table.types.js";
import { s as Ke } from "./Table.module-DJ8ngml8.js";
import { TableEmpty as ki } from "./components/Table/components/TableEmpty.js";
import { f as $i } from "./index-CxTlXOY2.js";
import { useIDSTableColumnStyles as Di } from "./components/Table/hooks/useIDSTableColumnStyles.js";
import { useIDSTableColumnSort as Ri } from "./components/Table/hooks/useIDSTableColumnSort.js";
import { useTable as Li } from "./components/Table/hooks/useTable.js";
import { TableBody as Ci } from "./components/Table/components/TableBody.js";
import { IressTableProvider as zi } from "./components/Table/TableProvider.js";
import "./components/TabSet/Tab/Tab.js";
import "./components/TabSet/TabSet.js";
import "./components/Toggle/Toggle.js";
import "./components/Tooltip/Tooltip.js";
import "./components/ValidationMessage/ValidationMessage.js";
import "./constants/index.js";
import { L as Ys, s as me } from "./LogoFromSrc-BxM_9jmu.js";
import { IressValidationSummary as Js } from "./components/ValidationMessage/ValidationSummary/ValidationSummary.js";
import { getUniqueItemsByKey as Ei } from "./components/Field/helpers/getUniqueItemsByKey.js";
import { mapFieldProps as Me } from "./components/Form/Controller/helpers/mapFieldProps.js";
import { FieldLegend as Bi } from "./components/Field/components/FieldLegend.js";
import { formatObjectKey as Mi } from "./utils/helpers.formatting.js";
import { IressDivider as Zs } from "./components/Divider/Divider.js";
import { useMenu as Oi } from "./components/Menu/hooks/useMenu.js";
import { useRichSelectState as es } from "./components/Select/RichSelect/hooks/useRichSelectState.js";
import { useFilterFlags as Pi } from "./components/Filter/hooks/useFilterFlags.js";
import { usePopoverItem as er } from "./components/Popover/hooks/usePopoverItem.js";
import { composeRichSelectDescriptor as qt } from "./components/Select/RichSelect/helpers/composeRichSelectDescriptor.js";
import { useComboboxFlags as tr } from "./components/Combobox/hooks/useComboboxFlags.js";
import { useComboboxInlineCompletion as Ti } from "./components/Combobox/hooks/useComboboxInlineCompletion.js";
import { useAutocompleteFlags as Hi } from "./components/Autocomplete/hooks/useAutocompleteFlags.js";
const Ui = "ids-alert-v501", qi = "ids-alert--icon-v501", Wi = "ids-alert--heading-v501", ji = "ids-alert--wrapper-v501", Qi = "ids-alert--footer-v501", Gi = "ids-alert--danger-v501", Ki = "ids-alert--info-v501", Xi = "ids-alert--success-v501", Yi = "ids-alert--warning-v501", tt = {
  alert: Ui,
  icon: qi,
  heading: Wi,
  "iress-u-text": "ids-alert--iress-u-text-v501",
  wrapper: ji,
  footer: Qi,
  danger: Gi,
  info: Ki,
  success: Xi,
  warning: Yi
}, Ji = "ids-icon-v501", ct = {
  icon: Ji,
  "flip-horizontal": "ids-icon--flip-horizontal-v501",
  "flip-vertical": "ids-icon--flip-vertical-v501",
  "flip-both": "ids-icon--flip-both-v501",
  "rotate-180": "ids-icon--rotate-180-v501",
  "rotate-270": "ids-icon--rotate-270-v501",
  "rotate-90": "ids-icon--rotate-90-v501",
  "spin-half": "ids-icon--spin-half-v501",
  "iress-icon-rotation": "ids-icon--iress-icon-rotation-v501",
  "spin-1": "ids-icon--spin-1-v501",
  "spin-2": "ids-icon--spin-2-v501",
  "spin-3": "ids-icon--spin-3-v501",
  "mode-body": "ids-icon--mode-body-v501",
  "mode-muted": "ids-icon--mode-muted-v501",
  "mode-primary": "ids-icon--mode-primary-v501",
  "mode-info": "ids-icon--mode-info-v501",
  "mode-success": "ids-icon--mode-success-v501",
  "mode-warning": "ids-icon--mode-warning-v501",
  "mode-danger": "ids-icon--mode-danger-v501",
  "mode-positive": "ids-icon--mode-positive-v501",
  "mode-negative": "ids-icon--mode-negative-v501"
}, Zi = ({
  name: e,
  screenreaderText: s,
  set: t = "fal",
  rotate: i,
  fixedWidth: r,
  flip: n,
  size: o,
  spin: l,
  mode: m,
  className: p,
  ...v
}, u) => {
  const h = "fa-", x = {
    [ct.icon]: !0,
    [h + e]: !0,
    [t]: !!t,
    [`${h}fw`]: !!r,
    [h + o]: o !== void 0,
    [ct[`mode-${m}`]]: m !== void 0,
    [ct[`flip-${n}`]]: n !== void 0,
    [ct[`rotate-${i}`]]: i !== void 0,
    [ct[`spin-${l}`]]: l !== void 0
  }, y = R(p, x);
  return /* @__PURE__ */ d(
    "span",
    {
      ref: u,
      role: "img",
      className: y,
      ...s === void 0 || s === "" ? { "aria-hidden": "true" } : { "aria-label": s },
      ...v
    }
  );
}, ie = de(
  Zi
);
ie.displayName = "IressIcon";
ie.Spin = Qr;
ie.Size = js;
ie.Flip = Gr;
ie.Rotate = Kr;
ie.Set = Xr;
ie.Mode = Hr;
const ts = ({
  children: e,
  className: s,
  footer: t,
  heading: i,
  headingLevel: r = "h2",
  headingText: n,
  status: o = "info",
  ...l
}) => /* @__PURE__ */ M(
  pt,
  {
    className: R(
      s,
      `${tt.alert} ${tt[o]} iress-u-inline iress--gutter--sm iress--no-wrap`
    ),
    ...l,
    children: [
      /* @__PURE__ */ d(
        ie,
        {
          name: Yr[o],
          screenreaderText: `${o}: `,
          size: ie.Size.Lg,
          fixedWidth: !0,
          className: tt.icon
        }
      ),
      /* @__PURE__ */ M("div", { className: tt.wrapper, children: [
        (i || n) && /* @__PURE__ */ d("div", { className: tt.heading, children: /* @__PURE__ */ d(
          Qs,
          {
            component: "IressAlert",
            heading: i,
            headingText: n,
            HeadingTag: r,
            "data-testid": k(l["data-testid"], "heading")
          }
        ) }),
        e,
        t && /* @__PURE__ */ d("div", { className: tt.footer, children: t })
      ] })
    ]
  }
);
ts.HeadingLevel = Cs;
ts.Status = Ur;
const en = "ids-input-v501", tn = "ids-input--wrapper-v501", sn = "ids-input--addon-v501", rn = "ids-input--internal-v501", nn = "ids-input--prepend-v501", on = "ids-input--append-v501", an = "ids-input--watermark-v501", ln = "ids-input--form-control-v501", dn = "ids-input--readonly-control-v501", oe = {
  input: en,
  wrapper: tn,
  addon: sn,
  internal: rn,
  prepend: nn,
  append: on,
  watermark: an,
  formControl: ln,
  readonlyControl: dn
}, cn = "ids-spinner-v501", un = {
  spinner: cn
}, ss = ({
  className: e,
  name: s = "spinner-third",
  spin: t = "half",
  ...i
}) => /* @__PURE__ */ d(
  ie,
  {
    ...i,
    className: R(e, un.spinner),
    name: s,
    spin: t
  }
), Oe = de(
  (e, s) => {
    const {
      loading: t = !1,
      clearable: i = !1,
      defaultValue: r,
      onClear: n,
      width: o,
      prepend: l,
      append: m,
      onChange: p,
      className: v,
      watermark: u,
      ...h
    } = e, y = _e(null).current, { value: N, setValue: V } = Dt({
      component: "IressInput",
      defaultValue: r,
      value: e.value
    }), D = Gs(N), I = (A) => {
      V(""), y == null || y.focus();
      const P = new Event("change", {
        bubbles: !0
      });
      Object.defineProperty(P, "target", {
        writable: !1,
        value: { value: "", ...A.target }
      }), n == null || n(P);
    }, L = (A) => {
      const P = A.target.value;
      V(P), p == null || p(A, P);
    }, q = R(
      oe.input,
      v,
      ae.FormElement,
      {
        [`${ae.Width}--${o}`]: o == null ? void 0 : o.includes("perc"),
        [oe.watermark]: u
      }
    );
    return /* @__PURE__ */ d("div", { className: q, "data-testid": h["data-testid"], children: /* @__PURE__ */ M(
      "div",
      {
        className: R(
          oe.wrapper,
          ae.FormElementInner
        ),
        children: [
          l && /* @__PURE__ */ d("div", { className: `${oe.addon} ${oe.prepend}`, children: l }),
          /* @__PURE__ */ d(
            ei,
            {
              ...h,
              className: R({
                [`${ae.Width}--${o}`]: o && !(o != null && o.includes("perc"))
              }),
              value: D,
              onChange: L,
              ref: s
            }
          ),
          /* @__PURE__ */ M("div", { className: oe.internal, children: [
            t && /* @__PURE__ */ d(
              ss,
              {
                screenreaderText: t === !0 ? "loading" : t
              }
            ),
            D && i && /* @__PURE__ */ d(Zr, { onClick: I })
          ] }),
          m && /* @__PURE__ */ d("div", { className: `${oe.addon} ${oe.append}`, children: m })
        ]
      }
    ) });
  }
);
Oe.displayName = "IressInput";
Oe.Type = zs;
Oe.Width = Wt;
Oe.InputMode = si;
const rs = de(
  ({
    append: e,
    className: s,
    "data-testid": t,
    loading: i,
    label: r,
    prepend: n,
    ...o
  }, l) => /* @__PURE__ */ M(
    "div",
    {
      className: R(oe.input, s),
      "data-testid": t,
      children: [
        /* @__PURE__ */ M("div", { className: oe.wrapper, children: [
          n && /* @__PURE__ */ d("div", { className: `${oe.addon} ${oe.prepend}`, children: n }),
          /* @__PURE__ */ d(
            "div",
            {
              className: R(ti.formControl, oe.readonlyControl),
              children: r ?? o.value
            }
          ),
          /* @__PURE__ */ d("div", { className: oe.internal, children: i && /* @__PURE__ */ d(
            ss,
            {
              screenreaderText: i === !0 ? "loading" : i
            }
          ) }),
          e && /* @__PURE__ */ d("div", { className: `${oe.addon} ${oe.append}`, children: e })
        ] }),
        /* @__PURE__ */ d(
          "input",
          {
            ...o,
            type: "hidden",
            ref: l,
            "data-testid": k(t, "input")
          }
        )
      ]
    }
  )
);
rs.displayName = "ReadonlyInput";
const sr = de(
  ({
    children: e,
    className: s,
    "data-testid": t,
    name: i,
    required: r,
    width: n,
    value: o
  }, l) => {
    const m = xe(() => {
      var p;
      return String(
        ((p = Ks(e).find(
          (v) => v.value === o
        )) == null ? void 0 : p.label) || ""
      );
    }, [e, o]);
    return /* @__PURE__ */ d(
      rs,
      {
        className: s,
        "data-testid": k(t, "pseudo"),
        label: m,
        name: i,
        ref: l,
        required: r,
        width: n,
        value: Ft(o)
      }
    );
  }
);
sr.displayName = "SelectReadonly";
const fn = ({
  children: e,
  className: s,
  "data-testid": t,
  onChange: i,
  readonly: r,
  value: n,
  defaultValue: o,
  width: l,
  ...m
}, p) => {
  const v = Le(m), u = _e(null), { value: h, setValue: x } = Dt({
    component: "IressSelect",
    defaultValue: o,
    value: n
  }), y = Br.useCallback(
    (N) => ni(
      N,
      Ks(e)
    ),
    [e]
  );
  return at(p, () => u.current), /* @__PURE__ */ d(
    "div",
    {
      "data-testid": t,
      className: R(
        s,
        ri.select,
        ae.FormElement,
        {
          [ae.IgnoreStack]: !!l,
          [`${ae.Width}--${l}`]: !!l
        }
      ),
      children: r ? /* @__PURE__ */ d(
        sr,
        {
          "data-testid": k(t, "select"),
          id: v,
          name: m.name,
          onChange: (N) => {
            const V = y(N.currentTarget.value);
            x(V), i == null || i(N, V);
          },
          ref: (N) => u.current = N,
          value: h,
          width: l,
          children: e
        }
      ) : /* @__PURE__ */ d(
        ii,
        {
          ...m,
          "data-testid": k(t, "select"),
          id: v,
          onChange: (N) => {
            const V = y(N.currentTarget.value);
            x(V), i == null || i(N, V);
          },
          ref: (N) => {
            if (u.current = N, !h && (N != null && N.value)) {
              const V = y(N.value);
              x(V), i == null || i(qe(V), V);
            }
          },
          value: h,
          children: e
        }
      )
    }
  );
}, rr = de(fn);
rr.Width = Wt;
const mn = (e) => {
  const s = Oi();
  return /* @__PURE__ */ d(
    Zs,
    {
      ...e,
      role: (s == null ? void 0 : s.role) === "menu" ? void 0 : "presentation"
    }
  );
}, pn = ({
  loading: e,
  ...s
}) => e ? /* @__PURE__ */ d(
  ss,
  {
    ...s,
    fixedWidth: !0,
    screenreaderText: e === !0 ? "Loading" : e
  }
) : null, vn = ({
  append: e,
  attrs: s,
  children: t,
  className: i,
  fluid: r = !1,
  href: n,
  loading: o = !1,
  mode: l = "secondary",
  prepend: m,
  rel: p,
  target: v,
  type: u = "button",
  noWrap: h = !1,
  onClick: x,
  value: y,
  ...N
}, V) => {
  const D = Mr(), L = di({ value: y ?? (typeof t == "string" || typeof t == "number" || typeof t == "boolean" ? t : void 0) }), q = {
    [Qe.Base]: !0,
    [Qe.Fluid]: r === !0,
    [`${Qe.Mode}--${l}`]: !L,
    [Qe.NoWrap]: h === !0,
    [Qe.Loading]: o,
    [`${Qe.Fluid}--${r}`]: typeof r == "string"
  }, A = n === void 0 ? "button" : "a", P = A === "button" ? {
    type: u,
    "aria-describedby": o ? D : void 0
  } : { href: n, rel: p, target: v }, C = (O) => {
    o || (x == null || x(O), L == null || L.toggle());
  };
  return /* @__PURE__ */ M(
    A,
    {
      className: R(
        i,
        L == null ? void 0 : L.className,
        ae.FormElement,
        ae.FormElementInner,
        q
      ),
      ...P,
      ...s,
      ...L == null ? void 0 : L.props,
      ...N,
      onClick: C,
      ref: V,
      children: [
        m && /* @__PURE__ */ d(
          "span",
          {
            className: o === !0 ? ae.Hidden : Qe.Prepend,
            children: m
          }
        ),
        /* @__PURE__ */ d(pn, { loading: o, id: D }),
        t,
        e
      ]
    }
  );
}, Ae = de(vn);
Ae.Mode = ai;
Ae.Type = li;
Ae.Fluid = Es;
const hn = "ids-close-button-v501", gn = {
  closeButton: hn
}, vt = de(
  ({
    screenreaderText: e = "Close button",
    className: s,
    ...t
  }, i) => /* @__PURE__ */ d(
    Ae,
    {
      className: R(s, gn.closeButton),
      mode: Ae.Mode.Tertiary,
      ...t,
      ref: i,
      children: /* @__PURE__ */ d(ie, { name: "times", screenreaderText: e })
    }
  )
);
vt.displayName = "IressCloseButton";
const yn = ({
  append: e,
  canToggle: s,
  children: t,
  className: i,
  divider: r,
  id: n,
  onClick: o,
  onFocus: l,
  onKeyDown: m,
  prepend: p,
  role: v,
  selected: u,
  value: h,
  ...x
}, y) => {
  const N = Le({ id: n }), V = hi() ?? v, D = gi({ selected: u, value: h }), I = bi({
    canToggle: s,
    onClick: o,
    onFocus: l,
    onKeyDown: m,
    selected: u,
    value: h
  }), L = yi(
    {
      append: e,
      children: t,
      className: i,
      "data-testid": x["data-testid"],
      divider: r,
      id: N,
      prepend: p,
      role: V,
      selected: u,
      value: h
    },
    I
  ), q = _e(null);
  return at(y, () => q.current), _i(
    /* @__PURE__ */ d(Ae, { ...D, ...I, ...L, ...x }),
    V
  );
}, bn = de(yn), _n = ({
  className: e,
  divider: s,
  formattedLabel: t,
  hiddenOnMobile: i,
  label: r,
  meta: n,
  value: o,
  ...l
}) => s ? /* @__PURE__ */ d(mn, {}) : /* @__PURE__ */ M(
  bn,
  {
    className: R(e, {
      [ae.HiddenMobile]: i
    }),
    ...l,
    value: o ?? r,
    children: [
      t ?? r,
      n && /* @__PURE__ */ d("span", { className: "iress-display--block", children: n })
    ]
  }
), is = ({
  hideSelectedItems: e,
  items: s = [],
  limitDesktop: t,
  limitMobile: i,
  multiSelect: r,
  onChange: n,
  selected: o,
  selectedFirst: l,
  ...m
}) => {
  const p = xe(
    () => oi(o, r),
    [r, o]
  ), v = xe(() => {
    let h = l ? xn(s, o, p) : s;
    if (e) {
      const x = Fe(p);
      h = h.filter(
        (y) => !x.includes(
          Ft(y.value) ?? y.label
        )
      );
    }
    return Sn(h, t, i);
  }, [
    e,
    s,
    t,
    i,
    p,
    o,
    l
  ]), u = Ye(
    (h) => {
      const x = Nn(
        s,
        o,
        h
      );
      n == null || n(r ? x : x[0]);
    },
    [s, r, n, o]
  );
  return /* @__PURE__ */ d(
    fi,
    {
      ...m,
      multiSelect: r,
      onChange: u,
      role: "listbox",
      selected: p,
      children: v.map((h) => /* @__PURE__ */ Ds(
        _n,
        {
          ...h,
          "data-testid": k(m == null ? void 0 : m["data-testid"], "menu-item"),
          key: `${Gs(
            h.value ?? h.label
          )}`
        }
      ))
    }
  );
}, xn = (e, s, t) => {
  const i = Fe(s), r = Fe(t), n = e.filter(
    (o) => !r.includes(o.value ?? o.label)
  );
  return i.length && n.length ? i.concat([{ label: "", value: "", divider: !0 }]).concat(n) : i.concat(n);
}, Sn = (e, s, t) => e.map((i, r) => ({
  ...i,
  hiddenOnMobile: t ? r > t - 1 : !1
})).slice(0, s ?? e.length), Nn = (e, s, t) => {
  const i = Fe(s), r = Fe(t), n = (o) => (e == null ? void 0 : e.find(
    (m) => m.value === o || m.value === void 0 && m.label === o
  )) ?? i.find(
    (m) => m.value === o || m.value === void 0 && m.label === o
  );
  return r.map(n).filter((o) => o !== void 0);
}, ir = de(
  ({
    append: e = /* @__PURE__ */ d(ie, { name: "search" }),
    autoSelect: s = !0,
    className: t,
    clearable: i = !0,
    "data-testid": r,
    debounceThreshold: n,
    defaultValue: o,
    initialOptions: l,
    limitDesktop: m = 12,
    limitMobile: p = 6,
    noResultsText: v,
    onChange: u,
    onClear: h,
    options: x,
    popoverProps: {
      autoHighlight: y = !1,
      append: N,
      prepend: V,
      ...D
    } = {},
    value: I,
    watermark: L = !0,
    ...q
  }, A) => {
    const [P, C] = pe(!1), { value: O, setValue: j } = Dt({
      component: "IressAutocomplete",
      defaultValue: o,
      value: I
    }), H = (K, U) => {
      u == null || u(K, U), j(U), !U && l && C(!0);
    }, ee = (K) => {
      h == null || h(K), j("");
    }, w = (K) => {
      var re;
      const U = (re = Fe(K)) == null ? void 0 : re[0], W = Ft(U == null ? void 0 : U.value) ?? (U == null ? void 0 : U.label);
      u == null || u(qe(W), W), j(W), C(!1);
    }, S = () => {
      C(!1), T();
    }, { debouncedQuery: z, loading: B, results: E, stopSearch: T } = Rt({
      debounceThreshold: n,
      initialOptions: l,
      options: x,
      query: Ft(O)
    }), Q = Hi({
      debouncedQuery: z,
      loading: B,
      results: E,
      value: O
    });
    return /* @__PURE__ */ M(
      Yt,
      {
        ...D,
        activator: /* @__PURE__ */ d(
          Oe,
          {
            ...q,
            append: e,
            clearable: i,
            "data-testid": k(r, "input"),
            loading: B,
            minLength: l != null && l.length ? 0 : q.minLength,
            onChange: H,
            onClear: ee,
            value: O,
            watermark: L,
            ref: A
          }
        ),
        autoHighlight: y,
        className: R(t, bt.autocomplete),
        contentClassName: bt.popoverContent,
        "data-testid": r,
        onActivated: () => C(!0),
        onDeactivated: S,
        show: P,
        type: "listbox",
        children: [
          Q.showResults && /* @__PURE__ */ M(mt, { children: [
            V,
            /* @__PURE__ */ d(
              is,
              {
                changeOnBlur: s,
                className: bt.optionList,
                "data-testid": k(r, "menu"),
                hideSelectedItems: !0,
                items: E,
                limitDesktop: m,
                limitMobile: p,
                onChange: w,
                selected: { label: z }
              }
            ),
            N
          ] }),
          Q.showNoResults && /* @__PURE__ */ d(
            Xt,
            {
              noResultsText: v,
              styles: bt
            }
          )
        ]
      }
    );
  }
);
ir.displayName = "IressAutocomplete";
const ns = ({
  loading: e,
  noResultsText: s = "No results",
  results: t = [],
  show: i,
  value: r,
  ...n
}) => {
  const o = xe(() => e ? "loading" : i && !t.length ? s : i && t.length ? qt(t, "{{numOptions}} results") : qt(r) || "None selected", [e, s, t, i, r]);
  return /* @__PURE__ */ d("div", { ...n, className: ae.SROnly, children: o });
}, nr = ({
  append: e,
  dataTestId: s,
  noResultsText: t,
  prepend: i,
  showNoResults: r,
  showResults: n,
  ...o
}) => /* @__PURE__ */ M(mt, { children: [
  n && /* @__PURE__ */ M(mt, { children: [
    i,
    /* @__PURE__ */ d(
      is,
      {
        ...o,
        className: je.optionList,
        "data-testid": k(s, "menu")
      }
    ),
    e
  ] }),
  r && /* @__PURE__ */ d(Xt, { noResultsText: t, styles: je })
] }), Lt = de(
  ({
    append: e = /* @__PURE__ */ d(ie, { name: "search" }),
    autoSelect: s = !0,
    className: t,
    clearable: i = !0,
    "data-testid": r,
    debounceThreshold: n,
    defaultValue: o,
    hiddenInputProps: l,
    id: m,
    initialOptions: p,
    limitDesktop: v = 12,
    limitMobile: u = 6,
    name: h,
    noResultsText: x,
    onBlur: y,
    onChange: N,
    onClear: V,
    onFocus: D,
    onKeyDown: I,
    options: L,
    popoverProps: {
      append: q,
      prepend: A,
      ...P
    } = {},
    required: C,
    value: O,
    watermark: j = !0,
    ...H
  }, ee) => {
    const w = Le({ id: m }), S = `${w}-sr-text`, z = _e(null), [B, E] = pe(!1), { value: T, setValue: Q, getLabelsString: K, getValuesString: U } = es({
      component: "IressCombobox",
      defaultValue: o,
      value: O
    }), [W, re] = pe(""), [Z, X] = pe(K()), te = (c, f) => {
      re(f), X(f), f || (Q(void 0), N == null || N(qe(void 0), void 0), p && E(!0));
    }, ne = (c) => {
      V == null || V(c), re(""), X(""), Q(void 0), E(!1);
    }, ve = (c) => {
      D == null || D(c), W || re(Z);
    }, ye = (c) => {
      y == null || y(c), X(T ? K() : "");
    }, ke = (c) => {
      I == null || I(c), a.setKeyPressed(c.nativeEvent);
    }, Ce = (c) => {
      var F;
      const f = (F = Fe(c)) == null ? void 0 : F[0];
      Q(f), N == null || N(qe(f), f), X(f == null ? void 0 : f.label), E(!1);
    }, Pe = () => {
      E(!1), He();
    }, lt = (c) => {
      a.setKeyPressed(void 0), a.highlightQueryByActiveIndex(c);
    }, { debouncedQuery: Te, loading: he, results: ce, stopSearch: He } = Rt({
      debounceThreshold: n,
      initialOptions: p,
      options: L,
      query: W
    }), Ze = tr({
      debouncedQuery: Te,
      loading: he,
      results: ce
    }), a = Ti({
      autoSelect: s,
      debouncedQuery: Te,
      debounceThreshold: n,
      onChange: N,
      queryRef: z,
      results: ce,
      setTypedQuery: X,
      setValue: Q
    });
    return /* @__PURE__ */ M(
      "div",
      {
        className: R(t, je.combobox),
        "data-testid": r,
        children: [
          /* @__PURE__ */ d(
            Yt,
            {
              ...P,
              activator: /* @__PURE__ */ d(
                Oe,
                {
                  ...H,
                  append: e,
                  "aria-describedby": S,
                  clearable: i,
                  loading: he,
                  "data-testid": k(r, "input"),
                  id: w,
                  onBlur: ye,
                  onChange: te,
                  onClear: ne,
                  onFocus: ve,
                  onKeyDown: ke,
                  ref: z,
                  value: Z,
                  watermark: j
                }
              ),
              className: R(t, je.popover),
              contentClassName: je.popoverContent,
              minLength: p != null && p.length ? 0 : H.minLength,
              onActivated: () => E(!0),
              onDeactivated: Pe,
              onNavigate: lt,
              show: B,
              type: "listbox",
              "data-testid": k(r, "popover"),
              children: /* @__PURE__ */ d(
                nr,
                {
                  append: q,
                  dataTestId: r,
                  limitDesktop: v,
                  limitMobile: u,
                  noResultsText: x,
                  onChange: Ce,
                  prepend: A,
                  items: ce,
                  selected: T,
                  showNoResults: Ze.showNoResults,
                  showResults: Ze.showResults
                }
              )
            }
          ),
          /* @__PURE__ */ d(
            Xs,
            {
              hiddenInputProps: l,
              dataTestId: r,
              name: h,
              ref: ee,
              required: C,
              value: U()
            }
          ),
          /* @__PURE__ */ d(
            ns,
            {
              "data-testid": k(r, "results-sr-text"),
              id: S,
              loading: he,
              noResultsText: x,
              results: ce
            }
          )
        ]
      }
    );
  }
);
Lt.displayName = "IressCombobox";
Lt.DisplayMode = qr;
Lt.Width = Wt;
const or = de(
  ({
    append: e = /* @__PURE__ */ d(ie, { name: "search" }),
    autoSelect: s = !0,
    className: t,
    clearable: i = !0,
    "data-testid": r,
    debounceThreshold: n,
    defaultValue: o,
    hiddenInputProps: l,
    id: m,
    initialOptions: p,
    limitDesktop: v = 12,
    limitMobile: u = 6,
    multiOptionTagLimit: h = 4,
    name: x,
    noResultsText: y,
    onChange: N,
    onClear: V,
    options: D,
    popoverProps: {
      autoHighlight: I = !1,
      append: L,
      prepend: q,
      ...A
    } = {},
    required: P,
    selectedOptionsTagText: C = "options selected",
    value: O,
    watermark: j = !0,
    ...H
  }, ee) => {
    const w = Le({ id: m }), S = `${w}-sr-text`, [z, B] = pe(!1), { value: E, setValue: T, getValuesString: Q, getLabelsArray: K } = es({
      component: "IressMultiCombobox",
      defaultValue: o,
      multiple: !0,
      value: O
    }), [U, W] = pe(""), re = (he, ce) => {
      W(ce);
    }, Z = (he) => {
      V == null || V(he), W(""), T([]);
    }, X = (he) => {
      if (!U && he.key === "Backspace") {
        const ce = Fe(E).slice(0, -1);
        N == null || N(qe(ce), ce), T(ce);
      }
    }, te = (he) => {
      const ce = [], He = Fe(he).filter((Ze) => {
        const a = Ze.value ?? Ze.label;
        return ce.includes(a) ? !1 : (ce.push(a), !0);
      });
      N == null || N(qe(He), He), T(He);
    }, ne = (he) => {
      const ce = Fe(E).filter((He) => He.label !== he);
      N == null || N(qe(ce), ce), T(ce);
    }, ve = () => {
      N == null || N(qe([]), []), T([]);
    }, ye = () => {
      B(!1), lt();
    }, { debouncedQuery: ke, loading: Ce, results: Pe, stopSearch: lt } = Rt({
      debounceThreshold: n,
      initialOptions: p,
      options: D,
      query: U
    }), Te = tr({
      debouncedQuery: ke,
      loading: Ce,
      results: Pe
    });
    return /* @__PURE__ */ M(
      "div",
      {
        className: R(t, je.combobox),
        "data-testid": r,
        children: [
          /* @__PURE__ */ d(
            Yt,
            {
              ...A,
              activator: /* @__PURE__ */ d(
                Dr,
                {
                  ...H,
                  append: e,
                  "aria-describedby": S,
                  clearable: i,
                  "data-testid": k(r, "input"),
                  id: w,
                  loading: Ce,
                  minLength: p != null && p.length ? 0 : H.minLength,
                  onChange: re,
                  onClear: Z,
                  onKeyDown: X,
                  onTagDelete: ne,
                  onTagDeleteAll: ve,
                  selectedOptionsTagText: C,
                  tagLimit: h,
                  tags: K(),
                  value: U,
                  watermark: j
                }
              ),
              autoHighlight: I,
              className: R(t, je.input),
              contentClassName: je.popoverContent,
              onActivated: () => B(!0),
              onDeactivated: ye,
              show: z,
              type: "listbox",
              "data-testid": k(r, "popover"),
              children: /* @__PURE__ */ d(
                nr,
                {
                  append: L,
                  changeOnBlur: s,
                  dataTestId: r,
                  limitDesktop: v,
                  limitMobile: u,
                  multiSelect: !0,
                  noResultsText: y,
                  onChange: te,
                  prepend: q,
                  items: Pe,
                  selected: E,
                  selectedFirst: !0,
                  showNoResults: Te.showNoResults,
                  showResults: Te.showResults
                }
              )
            }
          ),
          /* @__PURE__ */ d(
            Xs,
            {
              hiddenInputProps: l,
              dataTestId: r,
              name: x,
              ref: ee,
              required: P,
              value: Q()
            }
          ),
          /* @__PURE__ */ d(
            ns,
            {
              "data-testid": k(r, "results-sr-text"),
              id: S,
              loading: Ce,
              noResultsText: y,
              results: Pe
            }
          )
        ]
      }
    );
  }
);
or.displayName = "IressMultiCombobox";
const Fn = "ids-field-v501", In = "ids-field--field-group-v501", wn = "ids-field--invalid-v501", Vn = "ids-field--label-v501", An = "ids-field--hidden-label-v501", kn = "ids-field--hint-v501", $n = "ids-field--error-summary-v501", it = {
  field: Fn,
  fieldGroup: In,
  invalid: wn,
  "ids-combobox": "ids-combobox-v501",
  "ids-validationMessage": "ids-validation-message-v501",
  label: Vn,
  hiddenLabel: An,
  hint: kn,
  errorSummary: $n
}, ar = ({
  error: e,
  errorMessages: s,
  hiddenLabel: t,
  hint: i,
  "data-parent-testid": r
}) => /* @__PURE__ */ M(mt, { children: [
  i && /* @__PURE__ */ d(
    "div",
    {
      className: R(it.hint, {
        [ae.SROnly]: t
      }),
      "data-testid": k(r, "hint"),
      children: i
    }
  ),
  e,
  s && /* @__PURE__ */ d(
    Js,
    {
      className: it.errorSummary,
      messages: Ei(s, "message"),
      "data-testid": k(r, "error")
    }
  )
] }), Dn = ({
  children: e,
  className: s,
  "data-testid": t,
  error: i,
  errorMessages: r,
  hiddenLabel: n,
  hint: o,
  htmlFor: l,
  label: m,
  optional: p,
  required: v,
  ...u
}) => {
  const h = xe(
    () => !!i || (r == null ? void 0 : r.length),
    [i, r == null ? void 0 : r.length]
  ), x = xe(
    () => !o && !i && !(r != null && r.length) ? null : /* @__PURE__ */ d(
      ar,
      {
        hint: o,
        error: i,
        errorMessages: r,
        hiddenLabel: n,
        "data-parent-testid": t
      }
    ),
    [t, i, r, n, o]
  );
  let y = l;
  return y === void 0 && Rs(e) && (y = Fe(e)[0].props.id), /* @__PURE__ */ M(
    "div",
    {
      className: R(s, {
        [it.field]: !0,
        [it.invalid]: h,
        [it.hiddenLabel]: n === !0
      }),
      "data-testid": t,
      ...u,
      children: [
        /* @__PURE__ */ d(
          pi,
          {
            append: x,
            className: it.label,
            "data-testid": k(t, "label"),
            hiddenLabel: n,
            htmlFor: y,
            optional: p,
            required: v,
            children: m
          }
        ),
        e
      ]
    }
  );
}, Rn = "ids-field-group--field-v501", Ln = "ids-field-group-v501", Cn = "ids-field-group--invalid-v501", zn = "ids-field-group--label-v501", En = "ids-field-group--hidden-label-v501", Bn = "ids-field-group--legend-v501", Mn = "ids-field-group--hint-v501", On = "ids-field-group--fields-v501", Pn = "ids-field-group--inline-v501", Tn = "ids-field-group--join-v501", Ge = {
  field: Rn,
  fieldGroup: Ln,
  invalid: Cn,
  "ids-combobox": "ids-combobox-v501",
  "ids-validationMessage": "ids-validation-message-v501",
  label: zn,
  hiddenLabel: En,
  "ids-label--hidden": "ids-label--hidden-v501",
  legend: Bn,
  hint: Mn,
  fields: On,
  inline: Pn,
  join: Tn,
  "ids-field": "ids-field-v501",
  "ids-field--invalid": "ids-field--invalid-v501"
}, Hn = ({
  children: e,
  className: s,
  "data-testid": t,
  error: i,
  errorMessages: r,
  hiddenLabel: n,
  hint: o,
  inline: l,
  join: m,
  label: p,
  optional: v,
  required: u,
  ...h
}) => {
  const x = xe(
    () => !!i || (r == null ? void 0 : r.length),
    [i, r == null ? void 0 : r.length]
  ), y = xe(
    () => !o && !i && !(r != null && r.length) ? null : /* @__PURE__ */ d(
      ar,
      {
        hint: o,
        error: i,
        errorMessages: r,
        hiddenLabel: n,
        "data-parent-testid": t
      }
    ),
    [t, i, r, n, o]
  );
  return /* @__PURE__ */ M(
    "fieldset",
    {
      className: R(s, Ge.fieldGroup, {
        [Ge.inline]: l,
        [Ge.invalid]: x,
        [Ge.hiddenLabel]: n,
        [Ge.join]: m
      }),
      "data-testid": t,
      ...h,
      children: [
        /* @__PURE__ */ d(
          Bi,
          {
            append: y,
            className: Ge.legend,
            "data-testid": k(t, "legend"),
            hiddenLabel: n,
            optional: v,
            required: u,
            children: p
          }
        ),
        /* @__PURE__ */ d("div", { className: Ge.fields, children: e })
      ]
    }
  );
}, Un = "ids-filter-v501", qn = "ids-filter--chevron-v501", Wn = "ids-filter--search-input-v501", jn = "ids-filter--option-list-v501", Qn = "ids-filter--no-results-v501", Gn = "ids-filter--utils-with-reset-v501", Kn = "ids-filter--utils-searchable-v501", Xn = "ids-filter--option-content-v501", Yn = "ids-filter--option-meta-v501", Jn = "ids-filter--option-meta-text-v501", Zn = "ids-filter--reset-v501", Ie = {
  filter: Un,
  chevron: qn,
  searchInput: Wn,
  optionList: jn,
  noResults: Qn,
  utilsWithReset: Gn,
  utilsSearchable: Kn,
  optionContent: Xn,
  optionMeta: Yn,
  optionMetaText: Jn,
  reset: Zn
}, lr = de(
  (e, s) => {
    const t = _e(null), { isActiveInPopover: i, ...r } = er();
    return at(s, () => t.current), /* @__PURE__ */ d(
      Oe,
      {
        ...e,
        ...r,
        autoCorrect: "off",
        className: R(Ie.searchInput, {
          [Ie.isActiveInPopover]: i
        }),
        ref: (n) => {
          var o, l;
          t.current = n, (l = r == null ? void 0 : r.ref) == null || l.call(r, ((o = t.current) == null ? void 0 : o.input) ?? null);
        },
        type: "search"
      }
    );
  }
);
lr.displayName = "FilterSearch";
const dr = de(
  (e, s) => {
    const t = _e(null), { isActiveInPopover: i, ...r } = er();
    return at(s, () => t.current), /* @__PURE__ */ d(
      Ae,
      {
        ...e,
        ...r,
        className: R(Ie.reset, {
          [Ie.isActiveInPopover]: i
        }),
        mode: Ae.Mode.Link,
        ref: (n) => {
          var o;
          t.current = n, (o = r == null ? void 0 : r.ref) == null || o.call(r, t.current);
        }
      }
    );
  }
);
dr.displayName = "FilterResetButton";
const eo = ({
  label: e,
  selectedOptionsText: s,
  value: t
}) => Fe(t).length ? `${e}: ${qt(t, s)}` : e, hs = {
  align: "bottom-start"
}, to = de(
  ({
    children: e,
    className: s,
    "data-testid": t,
    debounceThreshold: i,
    defaultValue: r,
    id: n,
    initialOptions: o,
    inputProps: l = {
      clearable: !0,
      prepend: /* @__PURE__ */ d(ie, { name: "search" }),
      watermark: !0
    },
    limitDesktop: m = 12,
    limitMobile: p = 6,
    label: v,
    multiSelect: u,
    onChange: h,
    onReset: x,
    options: y,
    popoverProps: {
      append: N,
      prepend: V,
      ...D
    } = hs,
    searchable: I,
    searchNoResultsText: L,
    selectedOptionsText: q,
    value: A,
    visibleResetButton: P,
    ...C
  }, O) => {
    const j = Le({ id: n }), H = `${j}-sr-text`, ee = _e(null), w = xe(
      () => I ?? typeof y == "function",
      [y, I]
    ), S = {
      clearable: !0,
      prepend: /* @__PURE__ */ d(ie, { name: "search" }),
      watermark: !0,
      ...l
    }, z = { ...hs, ...D }, { value: B, setValue: E } = es({
      component: "IressFilter",
      defaultValue: r,
      multiple: u,
      value: A
    }), [T, Q] = pe(""), [K, U] = pe(!1), W = (ke, Ce) => {
      Q(Ce);
    }, re = () => {
      Q("");
    }, Z = (ke) => {
      h == null || h(ke), E(ke), u || U(!1);
    }, X = () => {
      E(void 0), x == null || x(), u || U(!1);
    };
    at(O, () => ({
      element: ee.current ?? void 0,
      clearSearch: () => Q(""),
      reset: () => E(r)
    }));
    const { debouncedQuery: te, loading: ne, results: ve } = Rt({
      debounceThreshold: i,
      initialOptions: o ?? (typeof y == "function" ? void 0 : y),
      options: y,
      query: T
    }), ye = Pi({
      debouncedQuery: te,
      loading: ne,
      results: ve,
      searchable: w,
      visibleResetButton: P
    });
    return /* @__PURE__ */ M(
      "div",
      {
        ...C,
        className: R(s, Ie.filter, {
          [Ie.multiSelect]: u,
          [Ie.searchable]: I
        }),
        "data-testid": t,
        id: j,
        ref: ee,
        children: [
          /* @__PURE__ */ M(
            Jr,
            {
              ...z,
              activator: /* @__PURE__ */ M(
                Ae,
                {
                  "aria-describedby": H,
                  "data-testid": k(
                    t,
                    "activator-button__button"
                  ),
                  onClick: () => U(!0),
                  children: [
                    /* @__PURE__ */ d(
                      eo,
                      {
                        label: v,
                        selectedOptionsText: q,
                        value: B
                      }
                    ),
                    /* @__PURE__ */ d("span", { className: Ie.chevron })
                  ]
                }
              ),
              "data-testid": k(t, "popover"),
              show: K,
              onActivated: () => U(!0),
              onDeactivated: () => U(!1),
              type: "listbox",
              children: [
                V,
                ye.showHeader && /* @__PURE__ */ M(mt, { children: [
                  /* @__PURE__ */ M(It, { background: It.Background.Transparent, children: [
                    w && /* @__PURE__ */ d(
                      lr,
                      {
                        ...S,
                        className: Ie.searchInput,
                        "data-testid": k(t, "input"),
                        loading: ne,
                        onChange: W,
                        onClear: re
                      }
                    ),
                    P && /* @__PURE__ */ d(
                      dr,
                      {
                        "data-testid": k(t, "reset-button"),
                        onClick: X,
                        children: typeof P == "string" ? P : "Reset filter"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ d(Zs, { gutter: "none" })
                ] }),
                ye.showResults && /* @__PURE__ */ d(
                  is,
                  {
                    className: Ie.optionList,
                    "data-testid": k(t, "menu"),
                    items: ve,
                    limitDesktop: m,
                    limitMobile: p,
                    multiSelect: u,
                    onChange: Z,
                    selected: B,
                    selectedFirst: u
                  }
                ),
                ye.showNoResults && /* @__PURE__ */ d(
                  Xt,
                  {
                    noResultsText: L,
                    styles: Ie
                  }
                ),
                N
              ]
            }
          ),
          e,
          /* @__PURE__ */ d(
            ns,
            {
              "data-testid": k(t, "results-sr-text"),
              id: H,
              loading: ne,
              noResultsText: L,
              results: ve
            }
          )
        ]
      }
    );
  }
);
to.displayName = "IressFilter";
var ht = (e) => e.type === "checkbox", nt = (e) => e instanceof Date, ge = (e) => e == null;
const cr = (e) => typeof e == "object";
var le = (e) => !ge(e) && !Array.isArray(e) && cr(e) && !nt(e), ur = (e) => le(e) && e.target ? ht(e.target) ? e.target.checked : e.target.value : e, so = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, fr = (e, s) => e.has(so(s)), ro = (e) => {
  const s = e.constructor && e.constructor.prototype;
  return le(s) && s.hasOwnProperty("isPrototypeOf");
}, os = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function be(e) {
  let s;
  const t = Array.isArray(e);
  if (e instanceof Date)
    s = new Date(e);
  else if (e instanceof Set)
    s = new Set(e);
  else if (!(os && (e instanceof Blob || e instanceof FileList)) && (t || le(e)))
    if (s = t ? [] : {}, !t && !ro(e))
      s = e;
    else
      for (const i in e)
        e.hasOwnProperty(i) && (s[i] = be(e[i]));
  else
    return e;
  return s;
}
var gt = (e) => Array.isArray(e) ? e.filter(Boolean) : [], se = (e) => e === void 0, _ = (e, s, t) => {
  if (!s || !le(e))
    return t;
  const i = gt(s.split(/[,[\].]+?/)).reduce((r, n) => ge(r) ? r : r[n], e);
  return se(i) || i === e ? se(e[s]) ? t : e[s] : i;
}, we = (e) => typeof e == "boolean";
const wt = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Ve = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ze = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, mr = J.createContext(null), Ct = () => J.useContext(mr), io = (e) => {
  const { children: s, ...t } = e;
  return J.createElement(mr.Provider, { value: t }, s);
};
var pr = (e, s, t, i = !0) => {
  const r = {
    defaultValues: s._defaultValues
  };
  for (const n in e)
    Object.defineProperty(r, n, {
      get: () => {
        const o = n;
        return s._proxyFormState[o] !== Ve.all && (s._proxyFormState[o] = !i || Ve.all), t && (t[o] = !0), e[o];
      }
    });
  return r;
}, Ne = (e) => le(e) && !Object.keys(e).length, vr = (e, s, t, i) => {
  t(e);
  const { name: r, ...n } = e;
  return Ne(n) || Object.keys(n).length >= Object.keys(s).length || Object.keys(n).find((o) => s[o] === (!i || Ve.all));
}, xt = (e) => Array.isArray(e) ? e : [e], hr = (e, s, t) => !e || !s || e === s || xt(e).some((i) => i && (t ? i === s : i.startsWith(s) || s.startsWith(i)));
function as(e) {
  const s = J.useRef(e);
  s.current = e, J.useEffect(() => {
    const t = !e.disabled && s.current.subject && s.current.subject.subscribe({
      next: s.current.next
    });
    return () => {
      t && t.unsubscribe();
    };
  }, [e.disabled]);
}
function no(e) {
  const s = Ct(), { control: t = s.control, disabled: i, name: r, exact: n } = e || {}, [o, l] = J.useState(t._formState), m = J.useRef(!0), p = J.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), v = J.useRef(r);
  return v.current = r, as({
    disabled: i,
    next: (u) => m.current && hr(v.current, u.name, n) && vr(u, p.current, t._updateFormState) && l({
      ...t._formState,
      ...u
    }),
    subject: t._subjects.state
  }), J.useEffect(() => (m.current = !0, p.current.isValid && t._updateValid(!0), () => {
    m.current = !1;
  }), [t]), pr(o, t, p.current, !1);
}
var Re = (e) => typeof e == "string", gr = (e, s, t, i, r) => Re(e) ? (i && s.watch.add(e), _(t, e, r)) : Array.isArray(e) ? e.map((n) => (i && s.watch.add(n), _(t, n))) : (i && (s.watchAll = !0), t);
function oo(e) {
  const s = Ct(), { control: t = s.control, name: i, defaultValue: r, disabled: n, exact: o } = e || {}, l = J.useRef(i);
  l.current = i, as({
    disabled: n,
    subject: t._subjects.values,
    next: (v) => {
      hr(l.current, v.name, o) && p(be(gr(l.current, t._names, v.values || t._formValues, !1, r)));
    }
  });
  const [m, p] = J.useState(t._getWatch(i, r));
  return J.useEffect(() => t._removeUnmounted()), m;
}
var ls = (e) => /^\w*$/.test(e), yr = (e) => gt(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Y = (e, s, t) => {
  let i = -1;
  const r = ls(s) ? [s] : yr(s), n = r.length, o = n - 1;
  for (; ++i < n; ) {
    const l = r[i];
    let m = t;
    if (i !== o) {
      const p = e[l];
      m = le(p) || Array.isArray(p) ? p : isNaN(+r[i + 1]) ? {} : [];
    }
    e[l] = m, e = e[l];
  }
  return e;
};
function br(e) {
  const s = Ct(), { name: t, disabled: i, control: r = s.control, shouldUnregister: n } = e, o = fr(r._names.array, t), l = oo({
    control: r,
    name: t,
    defaultValue: _(r._formValues, t, _(r._defaultValues, t, e.defaultValue)),
    exact: !0
  }), m = no({
    control: r,
    name: t
  }), p = J.useRef(r.register(t, {
    ...e.rules,
    value: l,
    ...we(e.disabled) ? { disabled: e.disabled } : {}
  }));
  return J.useEffect(() => {
    const v = r._options.shouldUnregister || n, u = (h, x) => {
      const y = _(r._fields, h);
      y && (y._f.mount = x);
    };
    if (u(t, !0), v) {
      const h = be(_(r._options.defaultValues, t));
      Y(r._defaultValues, t, h), se(_(r._formValues, t)) && Y(r._formValues, t, h);
    }
    return () => {
      (o ? v && !r._state.action : v) ? r.unregister(t) : u(t, !1);
    };
  }, [t, r, o, n]), J.useEffect(() => {
    _(r._fields, t) && r._updateDisabledField({
      disabled: i,
      fields: r._fields,
      name: t,
      value: _(r._fields, t)._f.value
    });
  }, [i, t, r]), {
    field: {
      name: t,
      value: l,
      ...we(i) || m.disabled ? { disabled: m.disabled || i } : {},
      onChange: J.useCallback((v) => p.current.onChange({
        target: {
          value: ur(v),
          name: t
        },
        type: wt.CHANGE
      }), [t]),
      onBlur: J.useCallback(() => p.current.onBlur({
        target: {
          value: _(r._formValues, t),
          name: t
        },
        type: wt.BLUR
      }), [t, r]),
      ref: (v) => {
        const u = _(r._fields, t);
        u && v && (u._f.ref = {
          focus: () => v.focus(),
          select: () => v.select(),
          setCustomValidity: (h) => v.setCustomValidity(h),
          reportValidity: () => v.reportValidity()
        });
      }
    },
    formState: m,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!_(m.errors, t)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!_(m.dirtyFields, t)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!_(m.touchedFields, t)
      },
      isValidating: {
        enumerable: !0,
        get: () => !!_(m.validatingFields, t)
      },
      error: {
        enumerable: !0,
        get: () => _(m.errors, t)
      }
    })
  };
}
var ao = (e, s, t, i, r) => s ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: r || !0
  }
} : {}, gs = (e) => ({
  isOnSubmit: !e || e === Ve.onSubmit,
  isOnBlur: e === Ve.onBlur,
  isOnChange: e === Ve.onChange,
  isOnAll: e === Ve.all,
  isOnTouch: e === Ve.onTouched
}), ys = (e, s, t) => !t && (s.watchAll || s.watch.has(e) || [...s.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const ft = (e, s, t, i) => {
  for (const r of t || Object.keys(e)) {
    const n = _(e, r);
    if (n) {
      const { _f: o, ...l } = n;
      if (o) {
        if (o.refs && o.refs[0] && s(o.refs[0], r) && !i)
          break;
        if (o.ref && s(o.ref, o.name) && !i)
          break;
        ft(l, s);
      } else
        le(l) && ft(l, s);
    }
  }
};
var lo = (e, s, t) => {
  const i = gt(_(e, t));
  return Y(i, "root", s[t]), Y(e, t, i), e;
}, ds = (e) => e.type === "file", We = (e) => typeof e == "function", Vt = (e) => {
  if (!os)
    return !1;
  const s = e ? e.ownerDocument : 0;
  return e instanceof (s && s.defaultView ? s.defaultView.HTMLElement : HTMLElement);
}, St = (e) => Re(e), cs = (e) => e.type === "radio", At = (e) => e instanceof RegExp;
const bs = {
  value: !1,
  isValid: !1
}, _s = { value: !0, isValid: !0 };
var _r = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const s = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: s, isValid: !!s.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !se(e[0].attributes.value) ? se(e[0].value) || e[0].value === "" ? _s : { value: e[0].value, isValid: !0 } : _s
    ) : bs;
  }
  return bs;
};
const xs = {
  isValid: !1,
  value: null
};
var xr = (e) => Array.isArray(e) ? e.reduce((s, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : s, xs) : xs;
function Ss(e, s, t = "validate") {
  if (St(e) || Array.isArray(e) && e.every(St) || we(e) && !e)
    return {
      type: t,
      message: St(e) ? e : "",
      ref: s
    };
}
var st = (e) => le(e) && !At(e) ? e : {
  value: e,
  message: ""
}, Ns = async (e, s, t, i, r) => {
  const { ref: n, refs: o, required: l, maxLength: m, minLength: p, min: v, max: u, pattern: h, validate: x, name: y, valueAsNumber: N, mount: V, disabled: D } = e._f, I = _(s, y);
  if (!V || D)
    return {};
  const L = o ? o[0] : n, q = (w) => {
    i && L.reportValidity && (L.setCustomValidity(we(w) ? "" : w || ""), L.reportValidity());
  }, A = {}, P = cs(n), C = ht(n), O = P || C, j = (N || ds(n)) && se(n.value) && se(I) || Vt(n) && n.value === "" || I === "" || Array.isArray(I) && !I.length, H = ao.bind(null, y, t, A), ee = (w, S, z, B = ze.maxLength, E = ze.minLength) => {
    const T = w ? S : z;
    A[y] = {
      type: w ? B : E,
      message: T,
      ref: n,
      ...H(w ? B : E, T)
    };
  };
  if (r ? !Array.isArray(I) || !I.length : l && (!O && (j || ge(I)) || we(I) && !I || C && !_r(o).isValid || P && !xr(o).isValid)) {
    const { value: w, message: S } = St(l) ? { value: !!l, message: l } : st(l);
    if (w && (A[y] = {
      type: ze.required,
      message: S,
      ref: L,
      ...H(ze.required, S)
    }, !t))
      return q(S), A;
  }
  if (!j && (!ge(v) || !ge(u))) {
    let w, S;
    const z = st(u), B = st(v);
    if (!ge(I) && !isNaN(I)) {
      const E = n.valueAsNumber || I && +I;
      ge(z.value) || (w = E > z.value), ge(B.value) || (S = E < B.value);
    } else {
      const E = n.valueAsDate || new Date(I), T = (U) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + U), Q = n.type == "time", K = n.type == "week";
      Re(z.value) && I && (w = Q ? T(I) > T(z.value) : K ? I > z.value : E > new Date(z.value)), Re(B.value) && I && (S = Q ? T(I) < T(B.value) : K ? I < B.value : E < new Date(B.value));
    }
    if ((w || S) && (ee(!!w, z.message, B.message, ze.max, ze.min), !t))
      return q(A[y].message), A;
  }
  if ((m || p) && !j && (Re(I) || r && Array.isArray(I))) {
    const w = st(m), S = st(p), z = !ge(w.value) && I.length > +w.value, B = !ge(S.value) && I.length < +S.value;
    if ((z || B) && (ee(z, w.message, S.message), !t))
      return q(A[y].message), A;
  }
  if (h && !j && Re(I)) {
    const { value: w, message: S } = st(h);
    if (At(w) && !I.match(w) && (A[y] = {
      type: ze.pattern,
      message: S,
      ref: n,
      ...H(ze.pattern, S)
    }, !t))
      return q(S), A;
  }
  if (x) {
    if (We(x)) {
      const w = await x(I, s), S = Ss(w, L);
      if (S && (A[y] = {
        ...S,
        ...H(ze.validate, S.message)
      }, !t))
        return q(S.message), A;
    } else if (le(x)) {
      let w = {};
      for (const S in x) {
        if (!Ne(w) && !t)
          break;
        const z = Ss(await x[S](I, s), L, S);
        z && (w = {
          ...z,
          ...H(S, z.message)
        }, q(z.message), t && (A[y] = w));
      }
      if (!Ne(w) && (A[y] = {
        ref: L,
        ...w
      }, !t))
        return A;
    }
  }
  return q(!0), A;
};
function co(e, s) {
  const t = s.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = se(e) ? i++ : e[s[i++]];
  return e;
}
function uo(e) {
  for (const s in e)
    if (e.hasOwnProperty(s) && !se(e[s]))
      return !1;
  return !0;
}
function fe(e, s) {
  const t = Array.isArray(s) ? s : ls(s) ? [s] : yr(s), i = t.length === 1 ? e : co(e, t), r = t.length - 1, n = t[r];
  return i && delete i[n], r !== 0 && (le(i) && Ne(i) || Array.isArray(i) && uo(i)) && fe(e, t.slice(0, -1)), e;
}
var Pt = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (r) => {
      for (const n of e)
        n.next && n.next(r);
    },
    subscribe: (r) => (e.push(r), {
      unsubscribe: () => {
        e = e.filter((n) => n !== r);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, kt = (e) => ge(e) || !cr(e);
function Xe(e, s) {
  if (kt(e) || kt(s))
    return e === s;
  if (nt(e) && nt(s))
    return e.getTime() === s.getTime();
  const t = Object.keys(e), i = Object.keys(s);
  if (t.length !== i.length)
    return !1;
  for (const r of t) {
    const n = e[r];
    if (!i.includes(r))
      return !1;
    if (r !== "ref") {
      const o = s[r];
      if (nt(n) && nt(o) || le(n) && le(o) || Array.isArray(n) && Array.isArray(o) ? !Xe(n, o) : n !== o)
        return !1;
    }
  }
  return !0;
}
var Sr = (e) => e.type === "select-multiple", fo = (e) => cs(e) || ht(e), Tt = (e) => Vt(e) && e.isConnected, mo = (e) => le(e) && Object.values(e).some((s) => s), Nr = (e) => {
  for (const s in e)
    if (We(e[s]))
      return !0;
  return !1;
};
function $t(e, s = {}) {
  const t = Array.isArray(e);
  if (le(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || le(e[i]) && !Nr(e[i]) ? (s[i] = Array.isArray(e[i]) ? [] : {}, $t(e[i], s[i])) : ge(e[i]) || (s[i] = !0);
  return s;
}
function Fr(e, s, t) {
  const i = Array.isArray(e);
  if (le(e) || i)
    for (const r in e)
      Array.isArray(e[r]) || le(e[r]) && !Nr(e[r]) ? se(s) || kt(t[r]) ? t[r] = Array.isArray(e[r]) ? $t(e[r], []) : { ...$t(e[r]) } : Fr(e[r], ge(s) ? {} : s[r], t[r]) : t[r] = !Xe(e[r], s[r]);
  return t;
}
var _t = (e, s) => Fr(e, s, $t(s)), Ir = (e, { valueAsNumber: s, valueAsDate: t, setValueAs: i }) => se(e) ? e : s ? e === "" ? NaN : e && +e : t && Re(e) ? new Date(e) : i ? i(e) : e;
function Ht(e) {
  const s = e.ref;
  if (!(e.refs ? e.refs.every((t) => t.disabled) : s.disabled))
    return ds(s) ? s.files : cs(s) ? xr(e.refs).value : Sr(s) ? [...s.selectedOptions].map(({ value: t }) => t) : ht(s) ? _r(e.refs).value : Ir(se(s.value) ? e.ref.value : s.value, e);
}
var po = (e, s, t, i) => {
  const r = {};
  for (const n of e) {
    const o = _(s, n);
    o && Y(r, n, o._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: r,
    shouldUseNativeValidation: i
  };
}, ut = (e) => se(e) ? e : At(e) ? e.source : le(e) ? At(e.value) ? e.value.source : e.value : e, vo = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function Fs(e, s, t) {
  const i = _(e, t);
  if (i || ls(t))
    return {
      error: i,
      name: t
    };
  const r = t.split(".");
  for (; r.length; ) {
    const n = r.join("."), o = _(s, n), l = _(e, n);
    if (o && !Array.isArray(o) && t !== n)
      return { name: t };
    if (l && l.type)
      return {
        name: n,
        error: l
      };
    r.pop();
  }
  return {
    name: t
  };
}
var ho = (e, s, t, i, r) => r.isOnAll ? !1 : !t && r.isOnTouch ? !(s || e) : (t ? i.isOnBlur : r.isOnBlur) ? !e : (t ? i.isOnChange : r.isOnChange) ? e : !0, go = (e, s) => !gt(_(e, s)).length && fe(e, s);
const yo = {
  mode: Ve.onSubmit,
  reValidateMode: Ve.onChange,
  shouldFocusError: !0
};
function bo(e = {}) {
  let s = {
    ...yo,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: We(s.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: s.errors || {},
    disabled: s.disabled || !1
  }, i = {}, r = le(s.defaultValues) || le(s.values) ? be(s.defaultValues || s.values) || {} : {}, n = s.shouldUnregister ? {} : be(r), o = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, m, p = 0;
  const v = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, u = {
    values: Pt(),
    array: Pt(),
    state: Pt()
  }, h = gs(s.mode), x = gs(s.reValidateMode), y = s.criteriaMode === Ve.all, N = (a) => (c) => {
    clearTimeout(p), p = setTimeout(a, c);
  }, V = async (a) => {
    if (v.isValid || a) {
      const c = s.resolver ? Ne((await O()).errors) : await H(i, !0);
      c !== t.isValid && u.state.next({
        isValid: c
      });
    }
  }, D = (a, c) => {
    (v.isValidating || v.validatingFields) && (c.forEach((f) => {
      Y(t.validatingFields, f, a);
    }), t.isValidating = mo(t.validatingFields), u.state.next({
      validatingFields: t.validatingFields,
      isValidating: t.isValidating
    }));
  }, I = (a, c = [], f, F, b = !0, g = !0) => {
    if (F && f) {
      if (o.action = !0, g && Array.isArray(_(i, a))) {
        const $ = f(_(i, a), F.argA, F.argB);
        b && Y(i, a, $);
      }
      if (g && Array.isArray(_(t.errors, a))) {
        const $ = f(_(t.errors, a), F.argA, F.argB);
        b && Y(t.errors, a, $), go(t.errors, a);
      }
      if (v.touchedFields && g && Array.isArray(_(t.touchedFields, a))) {
        const $ = f(_(t.touchedFields, a), F.argA, F.argB);
        b && Y(t.touchedFields, a, $);
      }
      v.dirtyFields && (t.dirtyFields = _t(r, n)), u.state.next({
        name: a,
        isDirty: w(a, c),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      Y(n, a, c);
  }, L = (a, c) => {
    Y(t.errors, a, c), u.state.next({
      errors: t.errors
    });
  }, q = (a) => {
    t.errors = a, u.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, A = (a, c, f, F) => {
    const b = _(i, a);
    if (b) {
      const g = _(n, a, se(f) ? _(r, a) : f);
      se(g) || F && F.defaultChecked || c ? Y(n, a, c ? g : Ht(b._f)) : B(a, g), o.mount && V();
    }
  }, P = (a, c, f, F, b) => {
    let g = !1, $ = !1;
    const G = {
      name: a
    }, ue = !!(_(i, a) && _(i, a)._f.disabled);
    if (!f || F) {
      v.isDirty && ($ = t.isDirty, t.isDirty = G.isDirty = w(), g = $ !== G.isDirty);
      const Se = ue || Xe(_(r, a), c);
      $ = !!(!ue && _(t.dirtyFields, a)), Se || ue ? fe(t.dirtyFields, a) : Y(t.dirtyFields, a, !0), G.dirtyFields = t.dirtyFields, g = g || v.dirtyFields && $ !== !Se;
    }
    if (f) {
      const Se = _(t.touchedFields, a);
      Se || (Y(t.touchedFields, a, f), G.touchedFields = t.touchedFields, g = g || v.touchedFields && Se !== f);
    }
    return g && b && u.state.next(G), g ? G : {};
  }, C = (a, c, f, F) => {
    const b = _(t.errors, a), g = v.isValid && we(c) && t.isValid !== c;
    if (e.delayError && f ? (m = N(() => L(a, f)), m(e.delayError)) : (clearTimeout(p), m = null, f ? Y(t.errors, a, f) : fe(t.errors, a)), (f ? !Xe(b, f) : b) || !Ne(F) || g) {
      const $ = {
        ...F,
        ...g && we(c) ? { isValid: c } : {},
        errors: t.errors,
        name: a
      };
      t = {
        ...t,
        ...$
      }, u.state.next($);
    }
    D(!1, Object.keys(t.validatingFields).filter(($) => $ === a));
  }, O = async (a) => s.resolver(n, s.context, po(a || l.mount, i, s.criteriaMode, s.shouldUseNativeValidation)), j = async (a) => {
    const { errors: c } = await O(a);
    if (a)
      for (const f of a) {
        const F = _(c, f);
        F ? Y(t.errors, f, F) : fe(t.errors, f);
      }
    else
      t.errors = c;
    return c;
  }, H = async (a, c, f = {
    valid: !0
  }) => {
    for (const F in a) {
      const b = a[F];
      if (b) {
        const { _f: g, ...$ } = b;
        if (g) {
          const G = l.array.has(g.name), ue = await Ns(b, n, y, s.shouldUseNativeValidation && !c, G);
          if (ue[g.name] && (f.valid = !1, c))
            break;
          !c && (_(ue, g.name) ? G ? lo(t.errors, ue, g.name) : Y(t.errors, g.name, ue[g.name]) : fe(t.errors, g.name));
        }
        $ && await H($, c, f);
      }
    }
    return f.valid;
  }, ee = () => {
    for (const a of l.unMount) {
      const c = _(i, a);
      c && (c._f.refs ? c._f.refs.every((f) => !Tt(f)) : !Tt(c._f.ref)) && ne(a);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, w = (a, c) => (a && c && Y(n, a, c), !Xe(W(), r)), S = (a, c, f) => gr(a, l, {
    ...o.mount ? n : se(c) ? r : Re(a) ? { [a]: c } : c
  }, f, c), z = (a) => gt(_(o.mount ? n : r, a, e.shouldUnregister ? _(r, a, []) : [])), B = (a, c, f = {}) => {
    const F = _(i, a);
    let b = c;
    if (F) {
      const g = F._f;
      g && (!g.disabled && Y(n, a, Ir(c, g)), b = Vt(g.ref) && ge(c) ? "" : c, Sr(g.ref) ? [...g.ref.options].forEach(($) => $.selected = b.includes($.value)) : g.refs ? ht(g.ref) ? g.refs.length > 1 ? g.refs.forEach(($) => (!$.defaultChecked || !$.disabled) && ($.checked = Array.isArray(b) ? !!b.find((G) => G === $.value) : b === $.value)) : g.refs[0] && (g.refs[0].checked = !!b) : g.refs.forEach(($) => $.checked = $.value === b) : ds(g.ref) ? g.ref.value = "" : (g.ref.value = b, g.ref.type || u.values.next({
        name: a,
        values: { ...n }
      })));
    }
    (f.shouldDirty || f.shouldTouch) && P(a, b, f.shouldTouch, f.shouldDirty, !0), f.shouldValidate && U(a);
  }, E = (a, c, f) => {
    for (const F in c) {
      const b = c[F], g = `${a}.${F}`, $ = _(i, g);
      (l.array.has(a) || !kt(b) || $ && !$._f) && !nt(b) ? E(g, b, f) : B(g, b, f);
    }
  }, T = (a, c, f = {}) => {
    const F = _(i, a), b = l.array.has(a), g = be(c);
    Y(n, a, g), b ? (u.array.next({
      name: a,
      values: { ...n }
    }), (v.isDirty || v.dirtyFields) && f.shouldDirty && u.state.next({
      name: a,
      dirtyFields: _t(r, n),
      isDirty: w(a, g)
    })) : F && !F._f && !ge(g) ? E(a, g, f) : B(a, g, f), ys(a, l) && u.state.next({ ...t }), u.values.next({
      name: o.mount ? a : void 0,
      values: { ...n }
    });
  }, Q = async (a) => {
    const c = a.target;
    let f = c.name, F = !0;
    const b = _(i, f), g = () => c.type ? Ht(b._f) : ur(a), $ = (G) => {
      F = Number.isNaN(G) || G === _(n, f, G);
    };
    if (b) {
      let G, ue;
      const Se = g(), et = a.type === wt.BLUR || a.type === wt.FOCUS_OUT, Cr = !vo(b._f) && !s.resolver && !_(t.errors, f) && !b._f.deps || ho(et, _(t.touchedFields, f), t.isSubmitted, x, h), Bt = ys(f, l, et);
      Y(n, f, Se), et ? (b._f.onBlur && b._f.onBlur(a), m && m(0)) : b._f.onChange && b._f.onChange(a);
      const Mt = P(f, Se, et, !1), zr = !Ne(Mt) || Bt;
      if (!et && u.values.next({
        name: f,
        type: a.type,
        values: { ...n }
      }), Cr)
        return v.isValid && V(), zr && u.state.next({ name: f, ...Bt ? {} : Mt });
      if (!et && Bt && u.state.next({ ...t }), D(!0, [f]), s.resolver) {
        const { errors: us } = await O([f]);
        if ($(Se), F) {
          const Er = Fs(t.errors, i, f), fs = Fs(us, i, Er.name || f);
          G = fs.error, f = fs.name, ue = Ne(us);
        }
      } else
        G = (await Ns(b, n, y, s.shouldUseNativeValidation))[f], $(Se), F && (G ? ue = !1 : v.isValid && (ue = await H(i, !0)));
      F && (b._f.deps && U(b._f.deps), C(f, ue, G, Mt));
    }
  }, K = (a, c) => {
    if (_(t.errors, c) && a.focus)
      return a.focus(), 1;
  }, U = async (a, c = {}) => {
    let f, F;
    const b = xt(a);
    if (D(!0, b), s.resolver) {
      const g = await j(se(a) ? a : b);
      f = Ne(g), F = a ? !b.some(($) => _(g, $)) : f;
    } else
      a ? (F = (await Promise.all(b.map(async (g) => {
        const $ = _(i, g);
        return await H($ && $._f ? { [g]: $ } : $);
      }))).every(Boolean), !(!F && !t.isValid) && V()) : F = f = await H(i);
    return u.state.next({
      ...!Re(a) || v.isValid && f !== t.isValid ? {} : { name: a },
      ...s.resolver || !a ? { isValid: f } : {},
      errors: t.errors,
      isValidating: !1
    }), c.shouldFocus && !F && ft(i, K, a ? b : l.mount), F;
  }, W = (a) => {
    const c = {
      ...r,
      ...o.mount ? n : {}
    };
    return se(a) ? c : Re(a) ? _(c, a) : a.map((f) => _(c, f));
  }, re = (a, c) => ({
    invalid: !!_((c || t).errors, a),
    isDirty: !!_((c || t).dirtyFields, a),
    isTouched: !!_((c || t).touchedFields, a),
    isValidating: !!_((c || t).validatingFields, a),
    error: _((c || t).errors, a)
  }), Z = (a) => {
    a && xt(a).forEach((c) => fe(t.errors, c)), u.state.next({
      errors: a ? t.errors : {}
    });
  }, X = (a, c, f) => {
    const F = (_(i, a, { _f: {} })._f || {}).ref;
    Y(t.errors, a, {
      ...c,
      ref: F
    }), u.state.next({
      name: a,
      errors: t.errors,
      isValid: !1
    }), f && f.shouldFocus && F && F.focus && F.focus();
  }, te = (a, c) => We(a) ? u.values.subscribe({
    next: (f) => a(S(void 0, c), f)
  }) : S(a, c, !0), ne = (a, c = {}) => {
    for (const f of a ? xt(a) : l.mount)
      l.mount.delete(f), l.array.delete(f), c.keepValue || (fe(i, f), fe(n, f)), !c.keepError && fe(t.errors, f), !c.keepDirty && fe(t.dirtyFields, f), !c.keepTouched && fe(t.touchedFields, f), !c.keepIsValidating && fe(t.validatingFields, f), !s.shouldUnregister && !c.keepDefaultValue && fe(r, f);
    u.values.next({
      values: { ...n }
    }), u.state.next({
      ...t,
      ...c.keepDirty ? { isDirty: w() } : {}
    }), !c.keepIsValid && V();
  }, ve = ({ disabled: a, name: c, field: f, fields: F, value: b }) => {
    if (we(a)) {
      const g = a ? void 0 : se(b) ? Ht(f ? f._f : _(F, c)._f) : b;
      Y(n, c, g), P(c, g, !1, !1, !0);
    }
  }, ye = (a, c = {}) => {
    let f = _(i, a);
    const F = we(c.disabled);
    return Y(i, a, {
      ...f || {},
      _f: {
        ...f && f._f ? f._f : { ref: { name: a } },
        name: a,
        mount: !0,
        ...c
      }
    }), l.mount.add(a), f ? ve({
      field: f,
      disabled: c.disabled,
      name: a,
      value: c.value
    }) : A(a, !0, c.value), {
      ...F ? { disabled: c.disabled } : {},
      ...s.progressive ? {
        required: !!c.required,
        min: ut(c.min),
        max: ut(c.max),
        minLength: ut(c.minLength),
        maxLength: ut(c.maxLength),
        pattern: ut(c.pattern)
      } : {},
      name: a,
      onChange: Q,
      onBlur: Q,
      ref: (b) => {
        if (b) {
          ye(a, c), f = _(i, a);
          const g = se(b.value) && b.querySelectorAll && b.querySelectorAll("input,select,textarea")[0] || b, $ = fo(g), G = f._f.refs || [];
          if ($ ? G.find((ue) => ue === g) : g === f._f.ref)
            return;
          Y(i, a, {
            _f: {
              ...f._f,
              ...$ ? {
                refs: [
                  ...G.filter(Tt),
                  g,
                  ...Array.isArray(_(r, a)) ? [{}] : []
                ],
                ref: { type: g.type, name: a }
              } : { ref: g }
            }
          }), A(a, !1, void 0, g);
        } else
          f = _(i, a, {}), f._f && (f._f.mount = !1), (s.shouldUnregister || c.shouldUnregister) && !(fr(l.array, a) && o.action) && l.unMount.add(a);
      }
    };
  }, ke = () => s.shouldFocusError && ft(i, K, l.mount), Ce = (a) => {
    we(a) && (u.state.next({ disabled: a }), ft(i, (c, f) => {
      let F = a;
      const b = _(i, f);
      b && we(b._f.disabled) && (F || (F = b._f.disabled)), c.disabled = F;
    }, 0, !1));
  }, Pe = (a, c) => async (f) => {
    let F;
    f && (f.preventDefault && f.preventDefault(), f.persist && f.persist());
    let b = be(n);
    if (u.state.next({
      isSubmitting: !0
    }), s.resolver) {
      const { errors: g, values: $ } = await O();
      t.errors = g, b = $;
    } else
      await H(i);
    if (fe(t.errors, "root"), Ne(t.errors)) {
      u.state.next({
        errors: {}
      });
      try {
        await a(b, f);
      } catch (g) {
        F = g;
      }
    } else
      c && await c({ ...t.errors }, f), ke(), setTimeout(ke);
    if (u.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Ne(t.errors) && !F,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), F)
      throw F;
  }, lt = (a, c = {}) => {
    _(i, a) && (se(c.defaultValue) ? T(a, be(_(r, a))) : (T(a, c.defaultValue), Y(r, a, be(c.defaultValue))), c.keepTouched || fe(t.touchedFields, a), c.keepDirty || (fe(t.dirtyFields, a), t.isDirty = c.defaultValue ? w(a, be(_(r, a))) : w()), c.keepError || (fe(t.errors, a), v.isValid && V()), u.state.next({ ...t }));
  }, Te = (a, c = {}) => {
    const f = a ? be(a) : r, F = be(f), b = Ne(a), g = b ? r : F;
    if (c.keepDefaultValues || (r = f), !c.keepValues) {
      if (c.keepDirtyValues)
        for (const $ of l.mount)
          _(t.dirtyFields, $) ? Y(g, $, _(n, $)) : T($, _(g, $));
      else {
        if (os && se(a))
          for (const $ of l.mount) {
            const G = _(i, $);
            if (G && G._f) {
              const ue = Array.isArray(G._f.refs) ? G._f.refs[0] : G._f.ref;
              if (Vt(ue)) {
                const Se = ue.closest("form");
                if (Se) {
                  Se.reset();
                  break;
                }
              }
            }
          }
        i = {};
      }
      n = e.shouldUnregister ? c.keepDefaultValues ? be(r) : {} : be(g), u.array.next({
        values: { ...g }
      }), u.values.next({
        values: { ...g }
      });
    }
    l = {
      mount: c.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, o.mount = !v.isValid || !!c.keepIsValid || !!c.keepDirtyValues, o.watch = !!e.shouldUnregister, u.state.next({
      submitCount: c.keepSubmitCount ? t.submitCount : 0,
      isDirty: b ? !1 : c.keepDirty ? t.isDirty : !!(c.keepDefaultValues && !Xe(a, r)),
      isSubmitted: c.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: b ? [] : c.keepDirtyValues ? c.keepDefaultValues && n ? _t(r, n) : t.dirtyFields : c.keepDefaultValues && a ? _t(r, a) : {},
      touchedFields: c.keepTouched ? t.touchedFields : {},
      errors: c.keepErrors ? t.errors : {},
      isSubmitSuccessful: c.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, he = (a, c) => Te(We(a) ? a(n) : a, c);
  return {
    control: {
      register: ye,
      unregister: ne,
      getFieldState: re,
      handleSubmit: Pe,
      setError: X,
      _executeSchema: O,
      _getWatch: S,
      _getDirty: w,
      _updateValid: V,
      _removeUnmounted: ee,
      _updateFieldArray: I,
      _updateDisabledField: ve,
      _getFieldArray: z,
      _reset: Te,
      _resetDefaultValues: () => We(s.defaultValues) && s.defaultValues().then((a) => {
        he(a, s.resetOptions), u.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (a) => {
        t = {
          ...t,
          ...a
        };
      },
      _disableForm: Ce,
      _subjects: u,
      _proxyFormState: v,
      _setErrors: q,
      get _fields() {
        return i;
      },
      get _formValues() {
        return n;
      },
      get _state() {
        return o;
      },
      set _state(a) {
        o = a;
      },
      get _defaultValues() {
        return r;
      },
      get _names() {
        return l;
      },
      set _names(a) {
        l = a;
      },
      get _formState() {
        return t;
      },
      set _formState(a) {
        t = a;
      },
      get _options() {
        return s;
      },
      set _options(a) {
        s = {
          ...s,
          ...a
        };
      }
    },
    trigger: U,
    register: ye,
    handleSubmit: Pe,
    watch: te,
    setValue: T,
    getValues: W,
    reset: he,
    resetField: lt,
    clearErrors: Z,
    unregister: ne,
    setError: X,
    setFocus: (a, c = {}) => {
      const f = _(i, a), F = f && f._f;
      if (F) {
        const b = F.refs ? F.refs[0] : F.ref;
        b.focus && (b.focus(), c.shouldSelect && b.select());
      }
    },
    getFieldState: re
  };
}
function _o(e = {}) {
  const s = J.useRef(), t = J.useRef(), [i, r] = J.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: We(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: We(e.defaultValues) ? void 0 : e.defaultValues
  });
  s.current || (s.current = {
    ...bo(e),
    formState: i
  });
  const n = s.current.control;
  return n._options = e, as({
    subject: n._subjects.state,
    next: (o) => {
      vr(o, n._proxyFormState, n._updateFormState, !0) && r({ ...n._formState });
    }
  }), J.useEffect(() => n._disableForm(e.disabled), [n, e.disabled]), J.useEffect(() => {
    if (n._proxyFormState.isDirty) {
      const o = n._getDirty();
      o !== i.isDirty && n._subjects.state.next({
        isDirty: o
      });
    }
  }, [n, i.isDirty]), J.useEffect(() => {
    e.values && !Xe(e.values, t.current) ? (n._reset(e.values, n._options.resetOptions), t.current = e.values, r((o) => ({ ...o }))) : n._resetDefaultValues();
  }, [e.values, n]), J.useEffect(() => {
    e.errors && n._setErrors(e.errors);
  }, [e.errors, n]), J.useEffect(() => {
    n._state.mount || (n._updateValid(), n._state.mount = !0), n._state.watch && (n._state.watch = !1, n._subjects.state.next({ ...n._formState })), n._removeUnmounted();
  }), J.useEffect(() => {
    e.shouldUnregister && n._subjects.values.next({
      values: n._getWatch()
    });
  }, [e.shouldUnregister, n]), s.current.formState = pr(i, n), s.current;
}
const xo = "ids-form--alert-v501", So = {
  alert: xo
}, Je = ({
  valueAsChecked: e,
  ...s
}) => {
  const { field: t, fieldState: i } = br(s), { className: r, hiddenLabel: n } = s, { label: o, children: l, htmlFor: m, hint: p, optional: v, rules: u, required: h } = s, x = xe(() => {
    var D, I;
    return i.error ? Jt(
      (D = i.error) == null ? void 0 : D.message,
      (I = i.error) == null ? void 0 : I.type,
      u
    ) : "";
  }, [i, u]), y = {
    hiddenLabel: n,
    className: r,
    label: o,
    htmlFor: m,
    hint: p,
    optional: v,
    required: h
  }, N = l, V = {
    ...t,
    checked: e ? t.value ?? !1 : void 0,
    value: e ? void 0 : t.value,
    onChange: e ? (D) => {
      var I;
      return (I = t.onChange) == null ? void 0 : I.call(t, D.currentTarget.checked);
    } : t.onChange
  };
  return /* @__PURE__ */ d(
    Dn,
    {
      errorMessages: x ? [{ message: x }] : void 0,
      ...y,
      children: ot(N, V)
    }
  );
}, No = (e) => {
  const { fieldProps: s, ...t } = Me(e);
  return /* @__PURE__ */ d(Je, { ...s, children: /* @__PURE__ */ d(Oe, { ...t }) });
}, wr = (e) => {
  const { field: s, fieldState: t } = br(e), {
    className: i,
    hiddenLabel: r,
    label: n,
    children: o,
    rules: l,
    optional: m,
    required: p,
    hint: v
  } = e, u = xe(() => {
    var h, x;
    return t.error ? Jt(
      (h = t.error) == null ? void 0 : h.message,
      (x = t.error) == null ? void 0 : x.type,
      l
    ) : "";
  }, [t, l]);
  return /* @__PURE__ */ d(
    Hn,
    {
      className: i,
      hiddenLabel: r,
      errorMessages: u ? [{ message: u }] : void 0,
      label: n,
      optional: m,
      required: p,
      hint: v,
      children: ot(
        o,
        s
      )
    }
  );
}, Fo = (e) => {
  const { fieldProps: s, ...t } = Me(e);
  return /* @__PURE__ */ d(wr, { ...s, children: /* @__PURE__ */ d(vi, { ...t }) });
}, Io = (e) => {
  const { fieldProps: s, ...t } = Me(e);
  return /* @__PURE__ */ d(Je, { ...s, children: /* @__PURE__ */ d(rr, { ...t }) });
}, wo = (e) => {
  const { fieldProps: s, ...t } = Me({
    ...e,
    defaultChecked: void 0,
    defaultValue: e.defaultChecked
  });
  return /* @__PURE__ */ d(Je, { ...s, valueAsChecked: !0, children: /* @__PURE__ */ d(ci, { ...t }) });
}, Vo = (e) => {
  const { fieldProps: s, children: t, ...i } = Me(e);
  return /* @__PURE__ */ d(wr, { ...s, children: /* @__PURE__ */ d(ui, { ...i, children: t }) });
}, Ao = (e) => {
  const { fieldProps: s, ...t } = Me(e);
  return /* @__PURE__ */ d(Je, { ...s, children: /* @__PURE__ */ d(ir, { ...t }) });
}, ko = (e) => {
  const { fieldProps: s, ...t } = Me(e);
  return /* @__PURE__ */ d(Je, { ...s, children: /* @__PURE__ */ d(Lt, { ...t }) });
}, $o = (e) => {
  const { fieldProps: s, ...t } = Me(e);
  return /* @__PURE__ */ d(Je, { ...s, children: /* @__PURE__ */ d(or, { ...t }) });
}, Do = (e = 0, s = 10, t = 1) => {
  const i = [];
  for (let r = e; r <= s; r += t)
    i.push(r);
  return i;
}, Ro = ({
  "data-testid": e,
  defaultValue: s,
  className: t,
  formatValue: i,
  hiddenValueTooltip: r,
  max: n = 10,
  min: o = 0,
  onChange: l,
  readonly: m,
  step: p = 1,
  tickLabels: v,
  value: u,
  ...h
}, x) => {
  const y = Le({ id: h == null ? void 0 : h.id }), V = (typeof v == "boolean" ? Do(o, n, p) : v ?? []).map(
    (A) => typeof A == "number" ? { value: A } : A
  ), { value: D, setValue: I } = Dt({
    component: "IressSlider",
    defaultValue: u ? void 0 : s ?? o,
    value: u
  }), L = Ye(() => {
    const A = V == null ? void 0 : V.find((P) => P.value === D);
    return i ? i(D ?? 0, A, m) : (A == null ? void 0 : A.label) ?? D;
  }, [V, i, D, m]), q = Ye(() => {
    const A = Number(((D ?? 0) - o) * 100 / (n - o));
    return `calc(${A}% + ((var(--iress-thumb-width) / 2) - ${A * 0.285}px))`;
  }, [n, o, D]);
  return m ? /* @__PURE__ */ d(
    rs,
    {
      "data-testid": k(e, "slider"),
      name: h == null ? void 0 : h.name,
      value: D,
      label: L()
    }
  ) : /* @__PURE__ */ M(
    "div",
    {
      className: R(t, Ot.slider),
      style: {
        "--iress-thumb-value-offset": q()
      },
      "data-testid": e,
      children: [
        !r && /* @__PURE__ */ d("output", { className: Ot.thumbValue, children: L() }),
        /* @__PURE__ */ d(
          "input",
          {
            className: Ot.control,
            max: n,
            min: o,
            step: p,
            ...h,
            value: D,
            type: "range",
            onChange: (A) => {
              l == null || l(A, Number(A.target.value)), I(Number(A.target.value));
            },
            ref: x,
            list: `${y}--markers`,
            "data-testid": k(e, "slider")
          }
        ),
        /* @__PURE__ */ d(
          xi,
          {
            tickLabels: V,
            id: `${y}--markers`,
            max: n,
            min: o,
            "data-testid": k(e, "datalist")
          }
        )
      ]
    }
  );
}, Vr = de(Ro);
Vr.displayName = "IressSlider";
const Lo = (e) => {
  const { fieldProps: s, ...t } = Me(e);
  return /* @__PURE__ */ d(Je, { ...s, children: /* @__PURE__ */ d(Vr, { ...t }) });
}, Co = (e) => e.type === Ao || e.type === wo || e.type === Vo || e.type === ko || e.type === No || e.type === $o || e.type === Fo || e.type === Io || e.type === Lo, Ar = (e, s, t) => Ls.map(e, (i) => {
  if (!Rs(i))
    return i;
  if (Co(i))
    return ot(i, {
      control: s,
      formId: t
    });
  if (i.props.children) {
    const r = {
      children: Ar(i.props.children, s, t)
    };
    return ot(i, r);
  }
  return i;
}), zo = ({
  alert: e,
  children: s,
  "data-testid": t,
  defaultValues: i,
  errorSummaryHeading: r = /* @__PURE__ */ d("h3", { children: mi.ErrorSummaryHeading }),
  errorSummaryHeadingText: n,
  errorSummaryHeadingLevel: o,
  gutter: l = "lg",
  onSubmit: m,
  onValidChange: p,
  onError: v,
  hiddenErrorSummary: u,
  // React hook forms - useForm hook
  context: h,
  criteriaMode: x,
  delayError: y,
  mode: N = "onSubmit",
  progressive: V,
  resetOptions: D,
  resolver: I,
  reValidateMode: L = "onChange",
  shouldFocusError: q,
  shouldUseNativeValidation: A,
  shouldUnregister: P,
  values: C,
  ...O
}, j) => {
  const H = Le({ id: O.id }), ee = _o({
    defaultValues: i,
    context: h,
    criteriaMode: x,
    delayError: y,
    mode: N,
    progressive: V,
    resetOptions: D,
    resolver: I,
    reValidateMode: L,
    shouldFocusError: q,
    shouldUseNativeValidation: A,
    shouldUnregister: P,
    values: C
  }), { handleSubmit: w, control: S, reset: z, formState: B } = ee, { errors: E, isValid: T } = B, K = !!Object.values(E).length && !u, U = Object.entries({ ...E }).map(
    ([X, te]) => {
      var ne, ve;
      return {
        linkToTarget: `${H}__${X}`,
        message: Jt(
          `${te == null ? void 0 : te.message}`,
          te == null ? void 0 : te.type,
          (ve = (ne = S._fields) == null ? void 0 : ne[X]) == null ? void 0 : ve._f,
          `${Mi(X)}: `
        )
      };
    }
  ), W = K || e, re = Ye(
    (X) => {
      w((te) => {
        m == null || m(te);
      }, v)(X);
    },
    [w, v, m]
  ), Z = _e(null);
  return at(j, () => ({
    element: (Z == null ? void 0 : Z.current) ?? void 0,
    api: ee,
    submit: () => re(),
    reset: (X) => z(X ?? i)
  })), Be(() => {
    p == null || p(T);
  }, [T, p]), /* @__PURE__ */ d(io, { ...ee, children: /* @__PURE__ */ M(
    "form",
    {
      ...O,
      id: H,
      onSubmit: re,
      noValidate: !0,
      "data-testid": t,
      ref: Z,
      className: R(
        O.className,
        "iress-u-stack",
        `iress--gutter--${l}`
      ),
      children: [
        /* @__PURE__ */ M(
          "div",
          {
            role: "alert",
            tabIndex: -1,
            className: R({
              [So.alert]: !0,
              [ae.Hidden]: !W
            }),
            children: [
              K ? /* @__PURE__ */ d(
                ts,
                {
                  status: "danger",
                  heading: r,
                  headingText: n,
                  headingLevel: o,
                  children: /* @__PURE__ */ d(
                    Js,
                    {
                      messages: U,
                      "data-testid": k(t, "error-summary")
                    }
                  )
                }
              ) : null,
              e
            ]
          }
        ),
        /* @__PURE__ */ d(
          "div",
          {
            className: R({
              [ae.IgnoreStack]: !K
            }),
            children: Ls.map(
              s,
              (X) => Ar(X, S, H)
            )
          }
        )
      ]
    }
  ) });
}, Eo = de(zo);
Eo.useForm = Ct;
const Bo = (e, s = {}) => {
  const t = Mo(s);
  return Object.keys(t).filter((i) => !!t[i]).map((i) => `${e}--${i}`);
}, Mo = (e = {}) => ms.reduce(
  (s, t, i) => (s[t] = e[t] ?? s[ms[i - 1]], s),
  {}
), Is = ({
  children: e,
  hiddenOn: s,
  visuallyHidden: t,
  className: i,
  ...r
}) => {
  const n = t ? vs.VisuallyHidden : vs.TotallyHidden;
  return /* @__PURE__ */ d(
    "div",
    {
      className: R(i, Bo(n, s)),
      ...r,
      children: e
    }
  );
}, yt = ({
  children: e,
  className: s,
  gutter: t = "none",
  horizontalAlign: i = "left",
  noWrap: r = !1,
  verticalAlign: n = "top",
  ...o
}) => {
  const l = {
    [`${rt.HorizontalAlign}--${i}`]: !0,
    [rt.NoWrap]: r,
    [`${rt.VerticalAlign}--${n}`]: !0
  }, m = R(
    s,
    rt.Base,
    Zt(rt.Gutter, t, "none"),
    l
  );
  return /* @__PURE__ */ d("div", { className: m, ...o, children: e });
};
yt.Gutter = jt;
yt.HorizontalAlign = Bs;
yt.VerticalAlign = Ms;
const Oo = "ids-modal-v501", Po = "ids-modal--backdrop-v501", To = "ids-modal--initial-v501", Ho = "ids-modal--close-v501", Uo = "ids-modal--open-v501", qo = "ids-modal--unmounted-v501", Wo = "ids-modal--close-button-v501", jo = "ids-modal--footer-v501", Qo = "ids-modal--fixed-footer-v501", Go = "ids-modal--content-v501", $e = {
  modal: Oo,
  backdrop: Po,
  "size--sm": "ids-modal--size--sm-v501",
  "size--lg": "ids-modal--size--lg-v501",
  "size--fullpage": "ids-modal--size--fullpage-v501",
  "size-xs--fullpage": "ids-modal--size-xs--fullpage-v501",
  "size-xs--sm": "ids-modal--size-xs--sm-v501",
  "size-xs--md": "ids-modal--size-xs--md-v501",
  "size-xs--lg": "ids-modal--size-xs--lg-v501",
  "size-sm--fullpage": "ids-modal--size-sm--fullpage-v501",
  "size-sm--sm": "ids-modal--size-sm--sm-v501",
  "size-sm--md": "ids-modal--size-sm--md-v501",
  "size-sm--lg": "ids-modal--size-sm--lg-v501",
  "size-md--fullpage": "ids-modal--size-md--fullpage-v501",
  "size-md--sm": "ids-modal--size-md--sm-v501",
  "size-md--md": "ids-modal--size-md--md-v501",
  "size-md--lg": "ids-modal--size-md--lg-v501",
  "size-lg--fullpage": "ids-modal--size-lg--fullpage-v501",
  "size-lg--sm": "ids-modal--size-lg--sm-v501",
  "size-lg--md": "ids-modal--size-lg--md-v501",
  "size-lg--lg": "ids-modal--size-lg--lg-v501",
  "size-xl--fullpage": "ids-modal--size-xl--fullpage-v501",
  "size-xl--sm": "ids-modal--size-xl--sm-v501",
  "size-xl--md": "ids-modal--size-xl--md-v501",
  "size-xl--lg": "ids-modal--size-xl--lg-v501",
  "size-xxl--fullpage": "ids-modal--size-xxl--fullpage-v501",
  "size-xxl--sm": "ids-modal--size-xxl--sm-v501",
  "size-xxl--md": "ids-modal--size-xxl--md-v501",
  "size-xxl--lg": "ids-modal--size-xxl--lg-v501",
  static: "ids-modal--static-v501",
  initial: To,
  close: Ho,
  open: Uo,
  unmounted: qo,
  closeButton: Wo,
  footer: jo,
  fixedFooter: Qo,
  content: Go
}, kr = ({
  children: e,
  className: s,
  closeText: t,
  container: i,
  "data-testid": r,
  defaultShow: n = !1,
  disableBackdropClick: o,
  fixedFooter: l,
  footer: m,
  heading: p,
  noCloseButton: v,
  onEntered: u,
  onExited: h,
  onShowChange: x,
  padding: y = "md",
  show: N,
  size: V = "md",
  static: D,
  style: I,
  ...L
}) => {
  const [q, A] = pe(n), P = _e(240), C = Si(L.id), O = Le({ id: L.id }), j = `${O}--heading`, H = C.opened || N || q;
  C.opened && N === !0 && Kt(
    "IressModal: Please use either IressModalProvider for uncontrolled components, or the show prop for controlled components, rather than both. If you use both, the open state of the modal will become unpredictable. If you want to show a modal by default in uncontrolled mode, use the defaultShow prop."
  );
  const ee = (Z) => {
    C.show(Z), A(Z), x == null || x(Z);
  }, { context: w } = Qt({
    open: H,
    onOpenChange: ee
  }), S = Ps(w, {
    enabled: !o,
    outsidePressEvent: "mousedown"
  }), z = Ts(w), B = Hs([S, z]), { isMounted: E, status: T } = Gt(w, {
    duration: {
      close: P.current
    }
  });
  Be(() => {
    var Z, X, te, ne;
    T === "initial" && ((Z = w.refs.floating) != null && Z.current) && (P.current = Ws(
      ((X = window.getComputedStyle(w.refs.floating.current, null)) == null ? void 0 : X.getPropertyValue("--iress-transition-duration")) || ".3s"
    ) * 0.8), T === "open" && (u == null || u(), (ne = (te = w.refs.floating) == null ? void 0 : te.current) == null || ne.focus()), T === "close" && (h == null || h());
  }, [T, u, h, w.refs.floating]);
  const Q = Zt(
    "size",
    V,
    "fullpage"
  ).map((Z) => $e[Z]), K = `iress-p--${y}`, U = R($e.modal, $e[T], {
    [$e.fixedFooter]: l
  }), W = xe(() => typeof p == "string" ? /* @__PURE__ */ d(
    pt,
    {
      id: j,
      element: pt.Element.H2,
      "data-testid": k(r, "heading"),
      children: p
    }
  ) : p ? ot(p, {
    id: j
  }) : null, [r, j, p]);
  if (!E)
    return null;
  const re = {
    position: "var(--iress-position, fixed)",
    ...I
  };
  return /* @__PURE__ */ d(Nt, { root: i ?? (C == null ? void 0 : C.container), children: /* @__PURE__ */ d(
    Us,
    {
      className: R(
        s,
        $e.backdrop,
        $e[T],
        Q,
        ae.IgnoreStack,
        {
          [$e.static]: D
        }
      ),
      "data-testid": k(r, "backdrop"),
      lockScroll: !D,
      style: re,
      children: /* @__PURE__ */ d(
        qs,
        {
          context: w,
          initialFocus: w.refs.floating,
          disabled: D,
          children: /* @__PURE__ */ M(
            "div",
            {
              ref: w.refs.setFloating,
              className: U,
              id: O,
              "data-testid": r,
              "aria-labelledby": W ? j : void 0,
              ...B.getFloatingProps(L),
              children: [
                !v && /* @__PURE__ */ d(
                  vt,
                  {
                    onClick: () => ee(!1),
                    screenreaderText: t,
                    className: $e.closeButton,
                    "data-testid": k(
                      r,
                      "close-button__button"
                    )
                  }
                ),
                /* @__PURE__ */ M(
                  "div",
                  {
                    className: R($e.content, K),
                    "data-testid": k(r, "content"),
                    children: [
                      W,
                      e
                    ]
                  }
                ),
                m && /* @__PURE__ */ d(
                  "div",
                  {
                    className: R($e.footer, K),
                    "data-testid": k(r, "footer"),
                    children: m
                  }
                )
              ]
            }
          )
        }
      )
    }
  ) });
};
kr.Size = Wr;
kr.Padding = Os;
const Ko = ({
  logoSrc: e,
  logoFound: s,
  logoAltText: t,
  onError: i,
  dataTestid: r
}) => e === "" ? null : s ? /* @__PURE__ */ d(
  Ys,
  {
    logoFound: s,
    logoSrc: e,
    logoAltText: t,
    onError: i,
    dataTestid: r
  }
) : /* @__PURE__ */ d(
  ie,
  {
    name: "home",
    screenreaderText: t,
    size: "2x",
    className: me.logoIcon
  }
), Xo = ({
  homeUrl: e,
  logoSrc: s,
  logoFound: t,
  logoAltText: i,
  onError: r,
  dataTestid: n
}) => e !== "" ? /* @__PURE__ */ d(
  "a",
  {
    href: e,
    className: R(me.logoLink, me.slot),
    "data-testid": k(n, "logo-link"),
    children: /* @__PURE__ */ d(
      Ko,
      {
        logoSrc: s,
        logoFound: t,
        logoAltText: i,
        onError: r,
        dataTestid: n
      }
    )
  }
) : s !== "" ? /* @__PURE__ */ d(
  Ys,
  {
    logoSrc: s,
    logoAltText: i,
    logoFound: t,
    onError: r,
    dataTestid: n
  }
) : null, $r = ({
  logo: e,
  nav: s,
  className: t,
  children: i,
  breakpoint: r,
  fixed: n = !1,
  handledFocus: o = !1,
  homeUrl: l = "",
  horizontalAlign: m,
  logoAltText: p = "",
  logoSrc: v = "",
  navLabel: u = "Main navigation",
  "data-testid": h,
  ...x
}) => {
  const y = _e(null), [N, V] = pe(!1), [D, I] = pe(!0), [L, q] = pe(!0), [A, P] = pe({}), C = Ye(() => {
    const S = L, z = {
      xs: S,
      sm: S,
      md: S,
      lg: S,
      xl: S,
      xxl: S
    };
    let B = !1;
    for (const E in z)
      B && (z[E] = !1), E === r && (B = !0);
    P(z);
  }, [r, L]);
  Be(() => {
    C(), s && V(!0), v !== "" && p === "" && Kt(
      "IressNavbar: You've supplied a logo but no alt text, which is a failure of WCAG Level A Success Criterion 1.1.1 - Non-text content. Set the logoAltText prop to add alt text to the logo.",
      "warn"
    );
  }, [C, s, v, p]), Be(() => (n && o && O(), () => {
    document.removeEventListener(
      "focus",
      j.bind(y),
      !0
    );
  }));
  const O = () => {
    const S = new ResizeObserver(j.bind(y));
    y.current && S.observe(y.current), document.addEventListener(
      "focus",
      j.bind(y),
      !0
    );
  }, j = () => {
    var z;
    const S = document.activeElement || document.body;
    if (y.current) {
      if (!(S !== document.body && !((z = y.current) != null && z.contains(S))))
        return;
      const E = S.getBoundingClientRect().top - y.current.getBoundingClientRect().bottom;
      E < 0 && window.scrollBy(0, E);
    }
  }, H = () => {
    q(!L), C();
  }, w = (() => {
    const S = ["xs", "sm", "md", "lg", "xl", "xxl"], B = S.indexOf(r) + 1;
    return B >= S.length ? {} : {
      [S[B]]: !0
    };
  })();
  return /* @__PURE__ */ d(
    "div",
    {
      className: R(t, {
        [me.navbar]: !0,
        [me.fixed]: n,
        [me[`breakpoint--${r}`]]: r !== void 0
      }),
      "data-testid": h,
      ref: y,
      ...x,
      children: /* @__PURE__ */ d("header", { children: /* @__PURE__ */ M(
        It,
        {
          padding: "none",
          background: "transparent",
          noBorderRadius: !0,
          className: me.panel,
          children: [
            r !== void 0 && /* @__PURE__ */ d(Is, { hiddenOn: w, children: /* @__PURE__ */ d(
              Ae,
              {
                onClick: () => H(),
                mode: Ae.Mode.Tertiary,
                className: me.toggleButton,
                "data-testid": k(
                  h,
                  "toggle-button__button"
                ),
                "aria-label": "Toggle navigation",
                "aria-controls": "iress-navbar__nav-slot",
                "aria-expanded": !L,
                children: /* @__PURE__ */ d(ie, { name: "bars", size: ie.Size.TwoTimes })
              }
            ) }),
            e ? /* @__PURE__ */ d("div", { className: me.logoSlot, children: e }) : /* @__PURE__ */ d(
              Xo,
              {
                homeUrl: l,
                logoSrc: v,
                logoFound: D,
                logoAltText: p,
                dataTestid: h,
                onError: () => I(!1)
              }
            ),
            /* @__PURE__ */ M(
              "div",
              {
                className: R({
                  [me.content]: !0,
                  [me.contentBetween]: m === "between",
                  [me.contentEnd]: m === "end",
                  [me.contentStart]: m === "start",
                  [me.slot]: !0
                }),
                children: [
                  i,
                  N && (r !== void 0 ? /* @__PURE__ */ d(Is, { hiddenOn: A, className: me.navHide, children: /* @__PURE__ */ d(
                    "nav",
                    {
                      "aria-label": u,
                      className: me.navSlot,
                      "data-testid": k(h, "nav"),
                      id: "iress-navbar__nav-slot",
                      children: s
                    }
                  ) }) : /* @__PURE__ */ d(
                    "nav",
                    {
                      "aria-label": u,
                      className: me.navSlot,
                      "data-testid": k(h, "nav"),
                      children: s
                    }
                  ))
                ]
              }
            )
          ]
        }
      ) })
    }
  );
};
$r.HorizontalAlign = Ni;
$r.Breakpoint = Es;
function Yo({
  children: e,
  className: s,
  gutter: t,
  horizontalAlign: i = "left",
  useColGap: r,
  verticalAlign: n = "top",
  ...o
}, l) {
  return /* @__PURE__ */ d(
    "div",
    {
      className: R(
        s,
        Zt(
          dt.Gutter,
          t,
          jt.None
        ),
        {
          [dt.Base]: !0,
          [`${dt.HorizontalAlign}--${i}`]: !!i,
          [`${dt.VerticalAlign}--${n}`]: !!n,
          [dt.UseColGap]: !!r
        }
      ),
      ...o,
      ref: l,
      children: e
    }
  );
}
const zt = de(
  Yo
);
zt.Gutter = jt;
zt.HorizontalAlign = Bs;
zt.VerticalAlign = Ms;
const Od = zt;
function Jo(e) {
  function s() {
    r && (t.length > 0 && /^[~+>]$/.test(t[t.length - 1]) && t.push(" "), t.push(r));
  }
  var t = [], i, r, n, o = [0], l = 0, m, p = /(?:[^\\]|(?:^|[^\\])(?:\\\\)+)$/, v = /^\s+$/, u = [
    /\s+|\/\*|["'>~+[(]/g,
    // general
    /\s+|\/\*|["'[\]()]/g,
    // [..] set
    /\s+|\/\*|["'[\]()]/g,
    // (..) set
    null,
    // string literal (placeholder)
    /\*\//g
    // comment
  ];
  for (e = e.trim(); ; )
    if (r = "", n = u[o[o.length - 1]], n.lastIndex = l, i = n.exec(e), i)
      if (m = l, l = n.lastIndex, m < l - i[0].length && (r = e.substring(
        m,
        l - i[0].length
      )), o[o.length - 1] < 3) {
        if (s(), i[0] === "[")
          o.push(1);
        else if (i[0] === "(")
          o.push(2);
        else if (/^["']$/.test(i[0]))
          o.push(3), u[3] = new RegExp(i[0], "g");
        else if (i[0] === "/*")
          o.push(4);
        else if (/^[\])]$/.test(i[0]) && o.length > 0)
          o.pop();
        else if (/^(?:\s+|[~+>])$/.test(i[0]) && (t.length > 0 && !v.test(t[t.length - 1]) && o[o.length - 1] === 0 && t.push(" "), o[o.length - 1] === 1 && t.length === 5 && t[2].charAt(t[2].length - 1) === "=" && (t[4] = " " + t[4]), v.test(i[0])))
          continue;
        t.push(i[0]);
      } else
        t[t.length - 1] += r, p.test(t[t.length - 1]) && (o[o.length - 1] === 4 && (t.length < 2 || v.test(t[t.length - 2]) ? t.pop() : t[t.length - 1] = " ", i[0] = ""), o.pop()), t[t.length - 1] += i[0];
    else {
      r = e.substr(l), s();
      break;
    }
  return t.join("").trim();
}
function Zo(e, s = document, t = null) {
  return ea(e, !1, s, t);
}
function ea(e, s, t, i = null) {
  e = Jo(e);
  let r = t.querySelector(e);
  return document.head.createShadowRoot || document.head.attachShadow ? !s && r ? r : Ut(e, ",").reduce((o, l) => {
    if (!s && o)
      return o;
    const m = Ut(l.replace(/^\s+/g, "").replace(/\s*([>+~]+)\s*/g, "$1"), " ").filter((x) => !!x).map((x) => Ut(x, ">")), p = m.length - 1, v = m[p][m[p].length - 1], u = ra(v, t, i), h = ta(m, p, t);
    return s ? (o = o.concat(u.filter(h)), o) : (o = u.find(h), o || null);
  }, s ? [] : null) : s ? t.querySelectorAll(e) : r;
}
function ta(e, s, t) {
  return (i) => {
    let r = s, n = i, o = !1;
    for (; n && !sa(n); ) {
      let l = !0;
      if (e[r].length === 1)
        l = n.matches(e[r]);
      else {
        const m = [].concat(e[r]).reverse();
        let p = n;
        for (const v of m) {
          if (!p || !p.matches(v)) {
            l = !1;
            break;
          }
          p = ws(p, t);
        }
      }
      if (l && r === 0) {
        o = !0;
        break;
      }
      l && r--, n = ws(n, t);
    }
    return o;
  };
}
function Ut(e, s) {
  return e.match(/\\?.|^$/g).reduce((t, i) => (i === '"' && !t.sQuote ? (t.quote ^= 1, t.a[t.a.length - 1] += i) : i === "'" && !t.quote ? (t.sQuote ^= 1, t.a[t.a.length - 1] += i) : !t.quote && !t.sQuote && i === s ? t.a.push("") : t.a[t.a.length - 1] += i, t), { a: [""] }).a;
}
function sa(e) {
  return e.nodeType === Node.DOCUMENT_FRAGMENT_NODE || e.nodeType === Node.DOCUMENT_NODE;
}
function ws(e, s) {
  const t = e.parentNode;
  return t && t.host && t.nodeType === 11 ? t.host : t === s ? null : t;
}
function ra(e = null, s, t = null) {
  let i = [];
  if (t)
    i = t;
  else {
    const r = function(n) {
      for (let o = 0; o < n.length; o++) {
        const l = n[o];
        i.push(l), l.shadowRoot && r(l.shadowRoot.querySelectorAll("*"));
      }
    };
    s.shadowRoot && r(s.shadowRoot.querySelectorAll("*")), r(s.querySelectorAll("*"));
  }
  return e ? i.filter((r) => r.matches(e)) : i;
}
const ia = "ids-slideout-v501", na = "ids-slideout--backdrop-v501", oa = "ids-slideout--push-v501", aa = "ids-slideout--unmounted-v501", la = "ids-slideout--initial-v501", da = "ids-slideout--close-v501", ca = "ids-slideout--open-v501", ua = "ids-slideout--right-v501", fa = "ids-slideout--left-v501", ma = "ids-slideout--close-button-v501", pa = "ids-slideout--content-v501", va = "ids-slideout--footer-v501", De = {
  slideout: ia,
  backdrop: na,
  push: oa,
  "size--sm": "ids-slideout--size--sm-v501",
  "size--md": "ids-slideout--size--md-v501",
  "size--lg": "ids-slideout--size--lg-v501",
  unmounted: aa,
  initial: la,
  close: da,
  open: ca,
  right: ua,
  left: fa,
  closeButton: ma,
  content: pa,
  footer: va
}, Vs = ({
  children: e,
  closeText: s,
  "data-testid": t,
  floatingRef: i,
  footer: r,
  heading: n,
  onOpenChange: o,
  padding: l,
  ...m
}) => /* @__PURE__ */ M("div", { ref: i, ...m, "data-testid": t, children: [
  /* @__PURE__ */ d(
    vt,
    {
      onClick: () => o(!1),
      screenreaderText: s,
      className: De.closeButton,
      "data-testid": k(t, "close-button__button")
    }
  ),
  /* @__PURE__ */ M(
    "div",
    {
      className: R(De.content, `iress-p--${l}`),
      "data-testid": k(t, "content"),
      children: [
        n,
        e
      ]
    }
  ),
  r && /* @__PURE__ */ d(
    "div",
    {
      className: R(De.footer, `iress-p--${l}`),
      "data-testid": k(t, "footer"),
      children: r
    }
  )
] }), ha = "ids-slideout-push-element-v501", ga = "ids-slideout-push-element--right-v501", ya = "ids-slideout-push-element--left-v501", ba = "ids-slideout-push-element--open-v501", Ue = {
  slideoutPushElement: ha,
  right: ga,
  left: ya,
  open: ba,
  "size--sm": "ids-slideout-push-element--size--sm-v501",
  "size--md": "ids-slideout-push-element--size--md-v501",
  "size--lg": "ids-slideout-push-element--size--lg-v501"
}, Et = ({
  backdrop: e,
  children: s,
  className: t,
  closeText: i = "Close",
  container: r,
  "data-testid": n,
  defaultShow: o = !1,
  eleToPush: l,
  footer: m,
  heading: p,
  mode: v = "overlay",
  onEntered: u,
  onExited: h,
  onShowChange: x,
  padding: y = "md",
  position: N = "right",
  show: V,
  size: D = "sm",
  style: I,
  ...L
}) => {
  const [q, A] = pe(o), P = _e(240), C = _e(null), O = Vi(L.id), j = Le({ id: L.id }), H = `${j}--heading`, ee = O.opened || V || q;
  O.opened && V === !0 && Kt(
    "IressSlideout: Please use either IressSlideoutProvider for uncontrolled components, or the show prop for controlled components, rather than both. If you use both, the open state of the slideout will become unpredictable. If you want to show a slideout by default in uncontrolled mode, use the defaultShow prop."
  );
  const w = (W) => {
    O.show(W), A(W), x == null || x(W);
  }, { context: S } = Qt({
    open: ee,
    onOpenChange: w
  }), z = Ps(S, {
    enabled: !0,
    outsidePressEvent: "mousedown"
  }), B = Ts(S, {
    enabled: e === !0
  }), E = Hs([z, B]), { isMounted: T, status: Q } = Gt(S, {
    duration: P.current
  });
  Be(() => {
    if (v === "overlay")
      C.current = null;
    else {
      let W;
      typeof l == "string" ? W = Zo(l) : l instanceof Element ? W = l : W = l == null ? void 0 : l.current, C.current = W;
    }
    return () => {
      C.current = null;
    };
  }, [l, v]), Be(() => {
    var W, re, Z, X, te, ne, ve, ye;
    Q === "initial" && ((W = C == null ? void 0 : C.current) == null || W.classList.add(
      Ue.slideoutPushElement,
      Ue[N],
      Ue[`size--${D}`]
    ), (re = S.refs.floating) != null && re.current && (P.current = Ws(
      ((Z = window.getComputedStyle(S.refs.floating.current, null)) == null ? void 0 : Z.getPropertyValue("--iress-transition-duration")) || ".3s"
    ))), Q === "open" && (u == null || u(), (te = (X = S.refs.floating) == null ? void 0 : X.current) == null || te.focus(), (ne = C == null ? void 0 : C.current) == null || ne.classList.add(Ue.open)), Q === "close" && (h == null || h(), (ve = C == null ? void 0 : C.current) == null || ve.classList.remove(Ue.open)), Q === "unmounted" && ((ye = C == null ? void 0 : C.current) == null || ye.classList.remove(
      Ue.slideoutPushElement,
      Ue[N],
      Ue[`size--${D}`]
    ));
  }, [
    Q,
    u,
    h,
    S.refs.floating,
    C,
    N,
    D
  ]);
  const K = xe(() => typeof p == "string" ? /* @__PURE__ */ d(
    pt,
    {
      id: H,
      "data-testid": k(n, "heading"),
      element: pt.Element.H2,
      children: p
    }
  ) : p ? ot(p, {
    id: H
  }) : null, [n, H, p]);
  if (!T)
    return null;
  const U = {
    "aria-labelledby": K ? H : void 0,
    children: s,
    className: R(
      De.slideout,
      De[Q],
      De[N],
      De[`size--${D}`],
      ae.IgnoreStack,
      {
        [De.push]: v === "push" && C.current,
        [`${t}`]: t && !e
      }
    ),
    closeText: i,
    "data-testid": n,
    footer: m,
    floatingRef: S.refs.setFloating,
    heading: K,
    id: j,
    onOpenChange: w,
    padding: y,
    ...E.getFloatingProps(L)
  };
  if (e) {
    const W = {
      position: "var(--iress-position, fixed)",
      ...I
    };
    return /* @__PURE__ */ d(Nt, { root: r ?? (O == null ? void 0 : O.container), children: /* @__PURE__ */ d(
      Us,
      {
        className: R(
          t,
          De.backdrop,
          De[Q],
          ae.IgnoreStack
        ),
        "data-testid": k(n, "backdrop"),
        lockScroll: !0,
        style: W,
        children: /* @__PURE__ */ d(
          qs,
          {
            context: S,
            initialFocus: S.refs.floating,
            children: /* @__PURE__ */ d(Vs, { ...U, "data-testid": n })
          }
        )
      }
    ) });
  }
  return /* @__PURE__ */ d(Nt, { root: r ?? (O == null ? void 0 : O.container), children: /* @__PURE__ */ d(
    Vs,
    {
      ...U,
      style: I,
      "data-testid": n
    }
  ) });
};
Et.Mode = Fi;
Et.Padding = Os;
Et.Position = Ii;
Et.Size = wi;
const _a = ({
  children: e,
  label: s = "sortable",
  sort: t,
  toggleSorting: i
}) => {
  const r = t != null && t.desc ? "sort-down" : "sort-up";
  return /* @__PURE__ */ M("button", { type: "button", className: Ke.sortButton, onClick: i, children: [
    e,
    /* @__PURE__ */ d(
      ie,
      {
        name: t ? r : "sort",
        className: Ke.sortIcon,
        screenreaderText: s
      }
    )
  ] });
}, xa = ({
  children: e,
  columnApi: s,
  tableId: t,
  ...i
}) => {
  const r = Ri({
    columnApi: s,
    columnKey: s.id
  }), n = Di({ columnKey: s.id });
  return /* @__PURE__ */ d(
    "th",
    {
      ...i,
      id: `${t}__${s.id}`,
      ...r == null ? void 0 : r.columnProps,
      ...n,
      children: s.getCanSort() && r ? /* @__PURE__ */ d(_a, { ...r == null ? void 0 : r.buttonProps, children: e }) : e
    }
  );
}, Sa = ({ tableId: e, ...s }) => {
  var r;
  const t = Li(), i = t == null ? void 0 : t.api.getHeaderGroups();
  return (r = t == null ? void 0 : t.api.getFlatHeaders()) != null && r.length ? /* @__PURE__ */ d("thead", { ...s, children: i.map((n) => /* @__PURE__ */ d(
    "tr",
    {
      "data-testid": k(s["data-testid"], "row", "-"),
      children: n.headers.map((o) => {
        var l;
        return /* @__PURE__ */ d(
          xa,
          {
            columnApi: o.column,
            tableId: e,
            "data-testid": k(
              (l = s["data-testid"]) == null ? void 0 : l.replace("thead", "header"),
              o.id
            ),
            children: o.isPlaceholder ? null : $i(
              o.column.columnDef.header,
              o.getContext()
            )
          },
          o.id
        );
      })
    },
    n.id
  )) }) : null;
}, Na = ({
  caption: e,
  children: s,
  columns: t,
  className: i,
  "data-testid": r,
  empty: n,
  hiddenCaption: o,
  hiddenHeader: l,
  hover: m,
  rows: p = [],
  scope: v,
  ...u
}) => {
  var N;
  const h = Le({ id: u.id }), x = `${h}--caption`, y = s || n && ((N = Object.keys(t || {})) == null ? void 0 : N.length) || !!(p != null && p.length);
  return /* @__PURE__ */ d("div", { className: Ke.wrapper, "data-testid": r, children: y && /* @__PURE__ */ d(zi, { columns: t, rows: p, children: /* @__PURE__ */ M(
    "table",
    {
      ...u,
      className: R(i, Ke.table, {
        [Ke.hover]: m,
        [Ke.hiddenHeader]: l
      }),
      id: h,
      "data-testid": k(r, "table"),
      children: [
        /* @__PURE__ */ d(
          "caption",
          {
            id: x,
            className: R(Ke.caption, {
              [ae.SROnly]: o
            }),
            "data-testid": k(r, "caption"),
            children: e
          }
        ),
        !l && /* @__PURE__ */ d(
          Sa,
          {
            "data-testid": k(r, "thead"),
            tableId: h
          }
        ),
        /* @__PURE__ */ d(
          Ci,
          {
            "data-testid": k(r, "tbody"),
            tableId: h,
            scope: v,
            hiddenHeader: l
          }
        ),
        /* @__PURE__ */ d(ki, { children: n }),
        s
      ]
    }
  ) }) });
};
Na.Scope = Ai;
const Fa = "ids-tag-v501", Ia = "ids-tag--content-v501", As = {
  tag: Fa,
  content: Ia,
  "ids-menuItem": "ids-menu-item-v501",
  "ids-closeButton": "ids-close-button-v501",
  "ids-popover--activator": "ids-popover--activator-v501"
}, ks = ({
  children: e,
  className: s,
  "data-testid": t,
  deleteButton: i,
  deleteButtonText: r = "Delete",
  onDelete: n,
  onDeleteButtonBlur: o,
  ...l
}) => {
  const m = _e(null), p = () => {
    var v;
    n !== void 0 && n(((v = m.current) == null ? void 0 : v.textContent) ?? "");
  };
  return /* @__PURE__ */ M(
    "div",
    {
      className: R(s, "iress-u-text", As.tag),
      "data-testid": t,
      ...l,
      children: [
        /* @__PURE__ */ d("span", { ref: m, className: As.content, children: e }),
        i ?? /* @__PURE__ */ d(
          vt,
          {
            onClick: p,
            onBlur: o,
            screenreaderText: r,
            "data-testid": k(t, "delete-button__button")
          }
        )
      ]
    }
  );
}, wa = "ids-tag-list-input--input-v501", Va = "ids-tag-list-input-v501 ids-tag-list-input--input-v501", Aa = "ids-tag-list-input--tag-list-input__label-v501", ka = "ids-tag-list-input--tag-list-input__items-v501", $a = "ids-tag-list-input--tag-list-input__items-inner-v501", Da = "ids-tag-list-input--focus-v501", Ra = {
  input: wa,
  tagListInput: Va,
  "ids-input--addon": "ids-input--addon-v501",
  "ids-clear-button--clear": "ids-clear-button--clear-v501",
  tagListInput__label: Aa,
  tagListInput__items: ka,
  "ids-input--watermark": "ids-input--watermark-v501",
  "ids-inline": "ids-inline-v501",
  "ids-input": "ids-input-v501",
  tagListInput__itemsInner: $a,
  "iress-u-inline": "ids-tag-list-input--iress-u-inline-v501",
  "ids-tag": "ids-tag-v501",
  "pseudo-focus": "ids-tag-list-input--pseudo-focus-v501",
  focus: Da
}, La = ({
  "data-testid": e,
  deleteButton: s,
  onTagDelete: t,
  onTagDeleteAll: i,
  onTagDeleteButtonBlur: r,
  selectedOptionsTagText: n,
  tags: o = [],
  tagLimit: l = 5
}) => o.length <= l ? o.map((m) => /* @__PURE__ */ d(
  ks,
  {
    deleteButton: s,
    deleteButtonText: `Delete ${m}`,
    onDelete: t,
    onDeleteButtonBlur: r,
    "data-testid": k(e, "tag"),
    children: m
  },
  m
)) : /* @__PURE__ */ M(
  ks,
  {
    deleteButton: s,
    onDelete: i,
    onDeleteButtonBlur: r,
    "data-testid": k(e, "tag"),
    children: [
      String(o.length) || "0",
      " ",
      n
    ]
  }
), Dr = de(
  ({
    append: e,
    children: s,
    className: t,
    "data-testid": i,
    deleteButton: r,
    onTagDelete: n,
    onTagDeleteAll: o,
    onTagDeleteButtonBlur: l,
    prepend: m,
    selectedOptionsTagText: p = "selected",
    styles: v,
    tags: u = [],
    tagLimit: h = 5,
    watermark: x,
    ...y
  }, N) => {
    const V = (D) => (v == null ? void 0 : v[D]) ?? Ra[D];
    return /* @__PURE__ */ d(
      "div",
      {
        className: R(t, V("tagListInput")),
        "data-testid": i,
        children: /* @__PURE__ */ M(
          "div",
          {
            className: R(V("tagListInput__items"), {
              [oe.watermark]: x
            }),
            "data-testid": k(i, "items"),
            children: [
              m && /* @__PURE__ */ d(
                "div",
                {
                  className: R({
                    [oe.addon]: !0
                  }),
                  children: m
                }
              ),
              /* @__PURE__ */ d("div", { className: V("tagListInput__itemsInner"), children: /* @__PURE__ */ M(yt, { gutter: "xs", verticalAlign: "middle", children: [
                /* @__PURE__ */ d(
                  La,
                  {
                    "data-testid": i,
                    deleteButton: r,
                    onTagDelete: n,
                    onTagDeleteAll: o,
                    onTagDeleteButtonBlur: l,
                    selectedOptionsTagText: p,
                    tags: u,
                    tagLimit: h
                  }
                ),
                s,
                /* @__PURE__ */ d(
                  Oe,
                  {
                    ...y,
                    className: V("tagListInput__element"),
                    autoComplete: "off",
                    "data-testid": k(i, "input"),
                    type: zs.Search,
                    ref: N
                  }
                )
              ] }) }),
              e && /* @__PURE__ */ d(
                "div",
                {
                  className: R({
                    [oe.addon]: !0,
                    [oe.append]: !0
                  }),
                  children: e
                }
              )
            ]
          }
        )
      }
    );
  }
);
Dr.displayName = "IressTagListInput";
const Ca = "ids-toast-v501", za = "ids-toast--open-v501", Ea = "ids-toast--fade-v501", Ba = "ids-toast--panel-v501", Ma = "ids-toast--unmounted-v501", Oa = "ids-toast--toast__icon-v501", Pa = "ids-toast--toast__wrapper-v501", Ta = "ids-toast--toast__footer-v501", Ee = {
  toast: Ca,
  "start-x": "ids-toast--start-x-v501",
  "end-x": "ids-toast--end-x-v501",
  open: za,
  "start-y": "ids-toast--start-y-v501",
  "end-y": "ids-toast--end-y-v501",
  fade: Ea,
  panel: Ba,
  "toast--error": "ids-toast--toast--error-v501",
  "toast--success": "ids-toast--toast--success-v501",
  "toast--info": "ids-toast--toast--info-v501",
  unmounted: Ma,
  "iress-u-text": "ids-toast--iress-u-text-v501",
  toast__icon: Oa,
  toast__wrapper: Pa,
  toast__footer: Ta,
  "toast__close-button": "ids-toast--toast__close-button-v501"
}, Ha = ({ status: e }) => /* @__PURE__ */ d(
  ie,
  {
    name: {
      error: "ban",
      success: "check",
      info: "info-square"
    }[e],
    screenreaderText: `${e}: `,
    size: js.Lg,
    fixedWidth: !0,
    className: Ee.toast__icon
  }
), Ua = ({
  dismissible: e,
  onClose: s,
  "data-testid": t
}) => {
  if (e)
    return /* @__PURE__ */ d(
      vt,
      {
        "data-testid": t,
        className: Ee["toast__close-button"],
        onClick: s,
        screenreaderText: "Dismiss"
      }
    );
}, qa = ({ actions: e }) => e ? /* @__PURE__ */ d("div", { className: Ee.toast__footer, children: e }) : null, Wa = ({
  heading: e,
  dismissible: s = !0,
  onClose: t,
  content: i,
  children: r,
  actions: n,
  "data-testid": o
}) => /* @__PURE__ */ M(
  "div",
  {
    className: Ee.toast__wrapper,
    "data-testid": k(o, "content"),
    children: [
      e,
      /* @__PURE__ */ d(
        Ua,
        {
          "data-testid": k(o, "close-button__button"),
          dismissible: s,
          onClose: t
        }
      ),
      i ?? r,
      /* @__PURE__ */ d(qa, { actions: n })
    ]
  }
), ja = ({
  heading: e,
  headingLevel: s,
  headingText: t,
  status: i,
  actions: r,
  content: n,
  dismissible: o,
  onClose: l,
  children: m,
  "data-testid": p,
  className: v,
  ...u
}, h) => /* @__PURE__ */ d(
  "div",
  {
    ...u,
    "data-testid": p,
    className: R(
      v,
      Ee.toast,
      Ee[`toast--${i}`]
    ),
    tabIndex: -1,
    ref: h,
    children: /* @__PURE__ */ d(It, { className: R(rt.Base, Ee.panel), children: /* @__PURE__ */ M(yt, { gutter: "sm", verticalAlign: "top", noWrap: !0, children: [
      /* @__PURE__ */ d(Ha, { status: i }),
      /* @__PURE__ */ d(
        Wa,
        {
          "data-testid": p,
          status: i,
          heading: /* @__PURE__ */ d(
            Qs,
            {
              component: "IressToast",
              heading: e,
              headingText: t,
              HeadingTag: s,
              "data-testid": k(p, "heading")
            }
          ),
          actions: r,
          content: n,
          dismissible: o,
          onClose: l,
          children: m
        }
      )
    ] }) })
  }
), Rr = de(ja);
Rr.HeadingLevel = Cs;
const Qa = "ids-toaster-v501", $s = {
  toaster: Qa,
  "toaster__bottom-end": "ids-toaster--toaster__bottom-end-v501",
  "toaster__bottom-start": "ids-toaster--toaster__bottom-start-v501",
  "toaster__bottom-center": "ids-toaster--toaster__bottom-center-v501",
  "toaster__top-end": "ids-toaster--toaster__top-end-v501",
  "toaster__top-start": "ids-toaster--toaster__top-start-v501",
  "toaster__top-center": "ids-toaster--toaster__top-center-v501"
}, Ga = (e) => {
  const s = Or(Lr);
  if (s === void 0)
    throw new Error("useToaster must be used within a IressToasterProvider");
  const { show: t, setOptions: i, options: r, close: n } = s;
  return Be(() => {
    i({
      ...r,
      position: e ?? r.position
    });
  }, [e]), {
    success: (o) => {
      t({ ...o, status: "success" });
    },
    error: (o) => {
      t({ ...o, status: "error" });
    },
    info: (o) => {
      t({ ...o, status: "info" });
    },
    close: n,
    options: r
  };
}, Ka = ({
  animation: e,
  className: s,
  onClose: t,
  onTimeout: i,
  timeout: r = 6e3,
  ...n
}) => {
  const [o, l] = pe(!0), m = _e(240), { context: p } = Qt({
    open: o,
    onOpenChange: l
  }), { isMounted: v, status: u } = Gt(p, {
    duration: {
      close: m.current
    }
  });
  return Be(() => {
    r && setTimeout(() => {
      l(!1), setTimeout(() => i == null ? void 0 : i(), m.current);
    }, r);
  }, [i, r]), Be(() => {
    var h;
    u === "initial" && (m.current = jr(
      p.refs.floating.current
    )), u === "open" && ((h = p.refs.floating.current) == null || h.focus());
  }, [u, p.refs.floating]), v ? /* @__PURE__ */ d(
    Rr,
    {
      ...n,
      className: R(
        s,
        Ee[u],
        Ee[e ?? "fade"]
      ),
      onClose: (h) => {
        l(!1), setTimeout(() => t == null ? void 0 : t(h), m.current);
      },
      ref: p.refs.setFloating
    }
  ) : !1;
}, Xa = ({
  container: e,
  position: s = "bottom-end",
  toasts: t
}) => {
  const i = Ga();
  return /* @__PURE__ */ d(Nt, { root: e, children: /* @__PURE__ */ d(
    ps,
    {
      className: R(
        ae.IgnoreStack,
        $s.toaster,
        $s[`toaster__${s}`]
      ),
      gutter: ps.Gutter.Md,
      role: "alert",
      "aria-relevant": "additions",
      "aria-live": "assertive",
      children: t == null ? void 0 : t.map((r) => /* @__PURE__ */ Ds(
        Ka,
        {
          ...r,
          animation: Tr[s],
          key: r.id,
          onClose: (n) => {
            var o;
            i.close(r.id), (o = r.onClose) == null || o.call(r, n);
          },
          onTimeout: () => i.close(r.id),
          timeout: r.timeout
        }
      ))
    }
  ) });
}, Lr = Pr(
  void 0
), Pd = ({
  children: e,
  ...s
}) => {
  const [t, i] = pe([]), [r, n] = pe({
    position: "bottom-end",
    ...s
  }), o = (v) => i((u) => u == null ? void 0 : u.filter((h) => h.id !== v)), l = Ye(
    (v) => {
      var x;
      const u = `${(/* @__PURE__ */ new Date()).getTime()}`, h = (x = r.position) == null ? void 0 : x.includes("top");
      i((y = []) => [
        ...h ? [] : y,
        { ...v, id: u },
        ...h ? y : []
      ]);
    },
    [r.position]
  ), m = Ye(
    (v) => o(v),
    []
  ), p = xe(
    () => ({
      show: l,
      close: m,
      options: r,
      setOptions: n
    }),
    [m, r, l]
  );
  return /* @__PURE__ */ M(Lr.Provider, { value: p, children: [
    /* @__PURE__ */ d(Xa, { toasts: t, ...r }),
    e
  ] });
};
export {
  Mo as $,
  kr as A,
  $r as B,
  Od as C,
  rr as D,
  is as E,
  _n as F,
  Et as G,
  Vr as H,
  ts as I,
  ss as J,
  Na as K,
  ks as L,
  Dr as M,
  Rr as N,
  Lr as O,
  Pd as P,
  Ga as Q,
  rs as R,
  sr as S,
  ja as T,
  ns as U,
  nr as V,
  ar as W,
  lr as X,
  dr as Y,
  eo as Z,
  Bo as _,
  ir as a,
  Ko as a0,
  Xo as a1,
  Vs as a2,
  _a as a3,
  xa as a4,
  Sa as a5,
  Ha as a6,
  Ka as a7,
  Xa as a8,
  Ae as b,
  vt as c,
  Lt as d,
  or as e,
  Dn as f,
  Hn as g,
  to as h,
  Eo as i,
  Ao as j,
  wo as k,
  Vo as l,
  ko as m,
  No as n,
  $o as o,
  Fo as p,
  Io as q,
  Lo as r,
  Je as s,
  wr as t,
  Is as u,
  ie as v,
  yt as w,
  Oe as x,
  mn as y,
  bn as z
};
